var WDN = WDN || {};

// Main window resize listener
(function () {
	var handleWindowResize;
	var windowWidth = window.innerWidth;

	handleWindowResize = function () {
		if (windowWidth === window.innerWidth) return;
		window.dispatchEvent(new CustomEvent("window:resize", { detail: {} }));
		windowWidth = window.innerWidth;
	};

	window.addEventListener("resize", handleWindowResize);
})();

if (typeof WDN.Money === "undefined") {
	WDN.Money = (function () {
		var FormatMoney = function (cents, withDecimals) {
			var value = "",
				placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
				formatString = theme.money_format.replace(
					"amount_with_comma_separator",
					"amount_no_decimals"
				);

			if (withDecimals) {
				formatString = theme.money_format.replace(
					"amount_no_decimals",
					"amount_with_comma_separator"
				);
			}

			if (typeof cents == "string") {
				cents = cents.replace(".", "");
			}

			function defaultOption(opt, def) {
				return typeof opt == "undefined" ? def : opt;
			}

			function formatWithDelimiters(number, precision, thousands, decimal) {
				precision = defaultOption(precision, 2);
				thousands = defaultOption(thousands, ",");
				decimal = defaultOption(decimal, ".");

				if (isNaN(number) || number == null) {
					return 0;
				}

				number = (number / 100.0).toFixed(precision);

				var parts = number.split("."),
					dollars = parts[0].replace(
						/(\d)(?=(\d\d\d)+(?!\d))/g,
						"$1" + thousands
					),
					cents = parts[1] ? decimal + parts[1] : "";

				return dollars + cents;
			}

			switch (formatString.match(placeholderRegex)[1]) {
				case "amount":
					value = formatWithDelimiters(cents, 2);
					break;
				case "amount_no_decimals":
					value = formatWithDelimiters(cents, 0);
					break;
				case "amount_with_comma_separator":
					value = formatWithDelimiters(cents, 2, ".", ",");
					break;
				case "amount_no_decimals_with_comma_separator":
					value = formatWithDelimiters(cents, 0, ".", ",");
					break;
			}

			return formatString.replace(placeholderRegex, value).replace(",00", "");
		};

		return {
			Format: FormatMoney,
		};
	})();
}

if (typeof WDN.Debounce === "undefined") {
	WDN.Debounce = (function () {
		var Debounce = function (Function, WaitTime) {
			var Timer;
			return function () {
				var This = this,
					args = arguments;
				var later = function () {
					Timer = null;
					Function.apply(This, args);
				};
				clearTimeout(Timer);
				Timer = setTimeout(later, WaitTime);
			};
		};
		return Debounce;
	})();
}

if (typeof WDN.Cart === "undefined") {
	WDN.Cart = (function () {
		// Include WDN.Request
		var Request = WDN.Request;

		if (!Request) {
			console.warn("Could not include WDN.Cart. WDN.Request was not found");
			return false;
		}

		// Public
		var Add, Update, Change, Get, Remove, Clear;

		// Private helpers
		var isFunction, onCartUpdate, _fireCustomEvent;

		isFunction = function (func) {
			return typeof func === "function";
		};

		GlobalRoutes = WDN.Routes;

		var Routes = {
			add: GlobalRoutes.cart_add_url + ".js",
			get: GlobalRoutes.cart_url + ".js",
			update: GlobalRoutes.cart_update_url + ".js",
			clear: GlobalRoutes.cart_clear_url + ".js",
			change: GlobalRoutes.cart_change_url + ".js",
		};

		Get = function (obj) {
			Request.Get({
				url: Routes.get,
				onSuccess: function (res) {
					onCartUpdate(res, "fetched");
					if (isFunction(obj.onSuccess)) {
						obj.onSuccess(res);
					}
				},
				onError: function (res) {
					onCartUpdate(res, "fetched");
					if (isFunction(obj.onError)) {
						obj.onError(res);
					}
				},
				type: "JSON",
			});
		};

		Add = function (obj) {
			Request.Post({
				url: Routes.add,
				data: obj.data,
				onSuccess: function (res) {
					onCartUpdate(res, "added");
					if (isFunction(obj.onSuccess)) {
						obj.onSuccess(res);
					}
				},
				onError: function (res) {
					onCartUpdate(res, "added");
					if (isFunction(obj.onError)) {
						obj.onError(res);
					}
				},
			});
		};

		Update = function (obj) {
			Request.Post({
				url: Routes.update,
				data: obj.data,
				onSuccess: function (res) {
					onCartUpdate(res, "updated");
					if (isFunction(obj.onSuccess)) {
						obj.onSuccess(res);
					}
				},
				onError: function (res) {
					onCartUpdate(res, "updated");
					if (isFunction(obj.onError)) {
						obj.onError(res);
					}
				},
			});
		};

		Clear = function (obj) {
			Request.Post({
				url: Routes.clear,
				onSuccess: function (res) {
					onCartUpdate(res, "cleared");
					if (obj) {
						if (isFunction(obj.onSuccess)) {
							obj.onSuccess(res);
						}
					}
				},
				onError: function (res) {
					onCartUpdate(res, "cleared");
					if (obj) {
						if (isFunction(obj.onError)) {
							obj.onError(res);
						}
					}
				},
			});
		};

		Remove = function (obj) {
			var data = {
				updates: { [obj.id]: 0 },
			};
			Update({ data: data, onSuccess: obj.onSuccess });
		};

		Change = function (obj) {
			Request.Post({
				url: Routes.change,
				data: obj.data,
				onSuccess: function (res) {
					onCartUpdate(res, "changed");
					if (isFunction(obj.onSuccess)) {
						obj.onSuccess(res);
					}
				},
				onError: function (res) {
					onCartUpdate(res, "changed");
					if (isFunction(obj.onError)) {
						obj.onError(res);
					}
				},
			});
		};

		onCartUpdate = function (res, action) {
			_fireCustomEvent(res, action);
		};

		_fireCustomEvent = function (res, action) {
			var eventName = "cart:" + action;
			var cartEvent = new CustomEvent(eventName, {
				detail: {
					res: res || false,
				},
			});
			document.body.dispatchEvent(cartEvent);
		};

		return {
			Add: Add,
			Update: Update,
			Get: Get,
			Remove: Remove,
			Clear: Clear,
			Change: Change,
		};
	})();
}

if (typeof WDN.Component === "undefined") {
	class WDNComponent extends HTMLElement {
		constructor() {
			super();
			this.Request = WDN.Request;
			this.Cart = WDN.Cart;
			this.Routes = WDN.Routes;
			this.Debounce = WDN.Debounce;
		}

		cartCount(action, newValue) {
			if (action !== "set" && action !== "update") {
				return;
			}
			this.fireEvent({
				name: "cartcount:" + action,
				detail: newValue || false,
			});
		}

		loading(newState, target) {
			var target = target || document.body;

			if (newState) {
				target.setAttribute("data-loading", "");
			} else {
				target.removeAttribute("data-loading");
			}

			this.isLoading = newState;
		}

		renderSections(target, res) {
			if (target) {
				var output = [];
				for (var key in res) {
					if (res.hasOwnProperty(key)) {
						output.push(res[key]);
					}
				}
				target.innerHTML = output.join("");
			}
		}

		fetchSections(ids, callback, _catch) {
			if (typeof this.Request === "object") {
				this.Request.Get({
					url: this.Routes.root_url + "?sections=" + ids,
					type: "JSON",
					onSuccess: typeof callback === "function" ? callback : false,
					onError: typeof _catch === "function" ? _catch : false,
				});
			}
		}

		callback(functionName, param) {
			typeof this[functionName] === "function" ? this[functionName](param) : "";
		}

		/**
		 *
		 * @param {object} data
		 */
		fireEvent(data) {
			var target = data.target || document.body;
			target.dispatchEvent(new CustomEvent(data.name, { detail: data.detail }));
		}

		/**
		 *
		 * @param {NodeList} targets
		 * @param {string} event
		 * @param {func} callback
		 */
		bindElements(targets, event, callback) {
			targets.forEach(function (target) {
				this.bindElement(target, event, callback);
			}, this);
		}

		/**
		 *
		 * @param {Node} target
		 * @param {string} event
		 * @param {func} callback
		 */
		bindElement(target, event, callback) {
			if (target && event && callback) {
				target.addEventListener(event, callback);
			}
		}

		/**
		 *
		 * @param {Node} target
		 * @param {string} event
		 * @param {func} callback
		 */
		unbindElement(target, event, callback) {
			if (target && event && callback) {
				target.removeEventListener(event, callback);
			}
		}
	}

	WDN.Component = WDNComponent;
}

/* HEADER  */
/* HEADER  */

if (typeof WDN.Header === "undefined") {
	WDN.Header = (function () {
		var init,
			bind,
			getHeight,
			getFullHeight,
			updateVariable,
			onVariableUpdate,
			windowOnResize,
			resetHeight,
			setStickyVariable;
		var adjustElement, getStickyHeaderHeight, storeHeight, getSearchbarHeight;

		var lastScrollTop = window.pageYOffset;

		var hasStickyHeader = false;
		var searchInputFocused = false;

		var nodes = {
			root: document.documentElement,
			header: document.querySelector("[data-header]"),
			sticky_header: document.querySelector(".nds__main"),
			mobile_search: document.querySelector(
				".header__mobile__search-bar__container"
			),
			mobile_seach_input: document.querySelector(
				".header-search--mobile .input--search"
			),
			topHeader: document.querySelector(".topHeader"),
		};

		var config = {
			variable_name: "--header-height", // Contains default header height
			full_variable_name: "--full-header-height", // Contains default header height + topHeader height
			sticky_variable_name: "--sticky-header-height", // Contains header height when fixed
			search_variable_name: "--mobile-searchbar-height", // Contains mobile searchbar height
		};

		var windowWidth = window.innerWidth;

		// Returns default header height
		getHeight = function () {
			return nodes.header.offsetHeight;
		};

		getFullHeight = function () {
			return nodes.header.offsetHeight + (nodes.topHeader?.offsetHeight || 0);
		};

		// Returns sticky header height
		getStickyHeaderHeight = function () {
			return nodes.sticky_header.offsetHeight;
		};

		getSearchbarHeight = function () {
			return nodes.mobile_search.offsetHeight;
		};

		updateVariable = function (newHeight) {
			if (typeof newHeight !== "number") return;
			nodes.root.style.setProperty(config.variable_name, newHeight + "px");
			nodes.root.style.setProperty(config.full_variable_name, getFullHeight() + "px");
			onVariableUpdate();
		};

		var onVariableUpdate = function () {
			document.body.dispatchEvent(
				new CustomEvent("header_height:updated", { detail: "" })
			);
		};

		resetHeight = function () {
			var headerHeight = getHeight();
			updateVariable(headerHeight);
		};

		var setStickyVariable = function (newHeight) {
			nodes.root.style.setProperty(
				config.sticky_variable_name,
				newHeight + "px"
			);
		};

		var setSearchVariable = function (newHeight) {
			nodes.root.style.setProperty(
				config.search_variable_name,
				newHeight + "px"
			);
		};

		var setHeightVariable = function (newHeight) {
			if (hasStickyHeader) return;
			nodes.root.style.setProperty(config.variable_name, newHeight + "px");
			nodes.root.style.setProperty(config.full_variable_name, getFullHeight() + "px");
		};

		var mobileFixedHeader = function () {
			if (window.pageYOffset >= 250) {
				if (window.pageYOffset > lastScrollTop) {
					if (searchInputFocused) return;
					document.body.classList.add("header--nosticky");
				} else {
					document.body.classList.remove("header--nosticky");
				}
			} else {
				document.body.classList.remove("header--nosticky");
			}
			lastScrollTop = window.pageYOffset;
		};

		windowOnResize = function () {
			if (windowWidth === window.innerWidth) return;
			storeHeight();
			windowWidth = window.innerWidth;
		};

		var windowOnScroll = function () {
			var scrollPos = window.scrollY;
			if (hasStickyHeader) {
				scrollPos +=
					document.body.style.getPropertyValue("--mobile-searchbar-height") ||
					49;
			}

			if (scrollPos >= 250) {
				nodes.header.classList.add("headerdesktop--fixed");
				document.body.classList.add("body--headerdesktop-fixed");
				hasStickyHeader = true;
				if (window.innerWidth <= 880) {
					setStickyVariable(getHeight() - nodes.mobile_search.offsetHeight);
				}
			} else {
				hasStickyHeader = false;
				document.body.classList.remove("body--headerdesktop-fixed");
				nodes.header.classList.remove("headerdesktop--fixed");
				if (window.innerWidth <= 880) {
					setStickyVariable(getHeight());
				}
			}
			mobileFixedHeader();
		};

		bind = function () {
			var windowOnResizeDebounced = WDN.Debounce(windowOnResize, 50);
			var windowOnScrollDebounced = WDN.Debounce(windowOnScroll, 50);
			window.addEventListener("window:resize", windowOnResizeDebounced);
			window.addEventListener("scroll", windowOnScrollDebounced);

			nodes.mobile_seach_input.addEventListener("focus", function () {
				searchInputFocused = true;
			});

			nodes.mobile_seach_input.addEventListener("focusout", function () {
				searchInputFocused = false;
			});
		};

		storeHeight = function () {
			setHeightVariable(getHeight());
			setStickyVariable(getStickyHeaderHeight());

			setSearchVariable(getSearchbarHeight());
		};

		init = function () {
			storeHeight();
			bind();
		};

		init();

		return { adjustElement, updateVariable, resetHeight, getHeight };
	})();
}

/* CART COUNT  */
/* CART COUNT  */
if (!customElements.get("wdn-cart-count")) {
	(function () {
		var isUpdating = false;

		// 2022 performance update - only 1 request per all cart counts
		var handleCartUpdate = function () {
			if (isUpdating) return;
			isUpdating = true;

			WDN.Cart.Get({
				onSuccess: function (res) {
					setValues(res);
					fireCartUpdateEvent(res);
					isUpdating = false;
				},
				onError: function () {
					isUpdating = false;
				},
			});
		};

		var fireCartUpdateEvent = function (res) {
			document.body.dispatchEvent(
				new CustomEvent("cart:updated", { detail: res })
			);
		};

		var setValues = function (res) {
			var counts = document.querySelectorAll("wdn-cart-count");
			counts.forEach(function (count) {
				count.setValue(res.item_count);
			});
		};

		document.body.addEventListener("cartcount:update", handleCartUpdate);

		class WDNCartCount extends WDN.Component {
			constructor() {
				super();
				this.output = this.querySelector("[data-value]");
				this.value = parseInt(this.output.getAttribute("data-value"));
				this.init();
			}

			show() {
				this.classList.remove("hidden");
			}

			hide() {
				this.classList.add("hidden");
			}

			toggle() {
				if (this.value > 0) {
					this.show();
				} else {
					this.hide();
				}
			}

			setValue(newValue) {
				if (this.value === parseInt(newValue)) return;
				this.value = parseInt(newValue);
				this.output.innerHTML = newValue;
				this.toggle();
			}

			onSet(e) {
				var newValue = e.detail;
				this.setValue(newValue);
			}

			onCartAdd(e) { }

			fireUpdatedEvent = function (res) {
				this.fireEvent({
					name: "cart:updated",
					detail: res,
				});
			};

			onCartFetch(res) {
				this.fireUpdatedEvent(res);
				this.setValue(res.item_count);
			}

			onCartError() { }

			bind() {
				this.bindElement(document.body, "cartcount:set", this.onSet.bind(this));
				this.bindElement(document.body, "cartcount:update", handleCartUpdate);
			}

			init() {
				this.bind();
			}
		}

		customElements.define("wdn-cart-count", WDNCartCount);
	})();
}

/* PRODUCT FORM */
/* PRODUCT FORM */
class WDNProductForm extends HTMLElement {
	constructor() {
		super();
		this.Routes = WDN.Routes;
		this.form = this.querySelector("form");

		this.submitButton = this.querySelector('button[type="submit"]');
		this.form.addEventListener("submit", this.onFormSubmit.bind(this));
		this.preventCartDrawer = this.getAttribute("data-prevent-drawer") === "";
		this.closeQuickshopOnAdd =
			this.getAttribute("data-close-quickshop-onadd") === "";
		this.maintainStateOnAdd =
			this.getAttribute("data-maintain-state-onadd") === "";
	}

	setButtonState(newState) {
		if (!this.submitButton) return;
		this.submitButton.setAttribute("data-state", newState);
	}

	fireEvent(obj) {
		var newEvent = new CustomEvent(obj.name, { detail: obj.detail });
		document.body.dispatchEvent(newEvent);
	}

	onSubmitSuccess(res) {
		this.fireEvent({ name: "cartcount:update" });
		this.setButtonState("success");

		if (this.closeQuickshopOnAdd) {
			var mobilequickshop = document.querySelector(
				"wdn-modal[data-id='mobile_quickshop']"
			);
			if (mobilequickshop) mobilequickshop.close();
		}

		if (!this.preventCartDrawer) {
			this.fireEvent({
				name: "product:added",
				detail: res,
			});
		}

		if (this.dataset.isQuickshopForm !== undefined) {
			this.fireEvent({
				name: "quickshop-product:added",
				detail: res,
			});
		}

		document
			.querySelector("wdn-cart")
			.reloadCart(this.preventCartDrawer, this.preventCartDrawer);

		typeof this.onAdd === "function" ? this.onAdd(res) : false;

		// If maintain state on add - do not update state back to default
		if (this.maintainStateOnAdd) return;

		setTimeout(
			function () {
				this.setButtonState(this.buttonState || "default");
			}.bind(this),
			1200
		);
	}

	surfaceError(str, scrollToError) {
		if (!str?.trim()) return;
		const errorBanner = this.querySelector("[data-product-form-error]");
		if (!errorBanner) return;
		errorBanner.innerText = str;
		if (scrollToError) {
			errorBanner.scrollIntoView({ behavior: "smooth", block: "center" });
		}
	}

	clearError() {
		const errorBanner = this.querySelector("[data-product-form-error]");
		if (!errorBanner) return;
		errorBanner.innerText = "";
	}

	onSubmitError(res, scrollToError) {
		this.setButtonState("default");
		this.fireEvent({
			name: "cart:error",
			detail: res,
		});

		this.surfaceError(res.description || res.message || "An error occurred.", scrollToError)
	}

	_submit(cb) {
		this.clearError();

		let formData = new FormData(this.form);
		if (!formData) {
			this.setButtonState("default");
			return;
		}

		fetch(window.Shopify.routes.root + "cart/add.js", {
			method: "POST",
			body: formData,
		})
			.then((response) => {
				return response.json();
			})
			.then((resJSON) => {
				if (resJSON.status && resJSON.status >= 400) {
					this.onSubmitError(resJSON, !this.form.closest(".quickshop"));
					return
				}
				var onSucc = this.onSubmitSuccess.bind(this);
				onSucc(resJSON);

				if (typeof cb === "function") {
					try {
						cb();
					} catch (error) {
						console.error(error);
					}
				}
			})
			.catch((error) => {
				console.error("Error:", error);
			});
	}

	storeInitialButtonState() {
		if (!this.submitButton) return;
		this.buttonState = this.submitButton.getAttribute("data-state");
	}

	promptUserConfirmPreorder() {
		var PreorderPopup = document.querySelector("wdn-preorder-popup");
		var productHandle = this.getAttribute("data-product-handle");

		var formData = new FormData(this.form);

		var variantId = formData.get("id");
		if (!variantId) {
			var variantId = formData.get("items[0][id]");
		}

		PreorderPopup.addedFromForm = this.form;
		PreorderPopup.openModalAndLoad(productHandle, variantId);
	}

	onFormSubmit(evt) {
		evt.preventDefault();
		var varSelect = this.querySelector("wdn-variant-select");

		if (
			this.querySelector('.quickshop__submit[data-state="preorder"]') ||
			this.querySelector(".quickshop-trigger--mobile--preorder")
		) {
			this.promptUserConfirmPreorder();
			return;
		}

		if (
			varSelect &&
			varSelect.stockState &&
			varSelect.stockState == "preorder"
		) {
			this.promptUserConfirmPreorder();
			return;
		}

		if (!varSelect) {
			if (this.querySelector("[data-trigger][data-state]")) {
				if (
					this.querySelector("[data-trigger][data-state]").getAttribute(
						"data-state"
					) === "preorder"
				) {
					this.promptUserConfirmPreorder();
					return;
				}
			}
		}

		this.storeInitialButtonState();
		this.setButtonState("loading");
		this._submit();
	}
}

customElements.define("wdn-product-form", WDNProductForm);

/* WDN SWIPER  */
/* WDN SWIPER  */

if (typeof WDN.SwiperConfig === "undefined") {
	WDN.SwiperConfig = (function () {
		var defaultConfig = {
			// default desktop
			speed: 525,
			perView: 4,
			shortSwipes: false,
			// default tablet
			tabletPerView: 2,
			tabletSpaceBetween: 15,
			// default mobile
			mobilePerView: 1,
			mobileSpaceBetween: 10,
		};
		return defaultConfig;
	})();
}

if (!customElements.get("wdn-swiper")) {
	class WDNSwiper extends HTMLElement {
		constructor() {
			super();
			this.isCreated = false;
			this.default = WDN.SwiperConfig;
			this.id = this.getAttribute("data-id");
			this.perView = this.getAttribute("data-perview").split("-"); // eg. 3-2-1
			this.spaceBetween = this.getAttribute("data-space-between").split("-"); // eg. 50-20-10
			this.isMobileOnly = this.getAttribute("data-mobileonly") === "";
			this.isLargeOnly = this.getAttribute("data-largeonly") === "";
			this.isCenteredOnMobile =
				this.getAttribute("data-mobile-centered") === "";
			this.isCentered = this.getAttribute("data-centered") === "";
			this.isLooped = this.getAttribute("data-loop") === "";
			this.slidesPerGroup =
				parseInt(this.getAttribute("data-group-slides")) || 1;
			this.autoplay = this.getAttribute("data-autoplay") === "";
			this.progressPagination =
				this.getAttribute("data-pagination-progress") === "";
			this.thumbs_id = this.getAttribute("data-thumbs");
			this.direction = this.getAttribute("data-direction");
			this.has_scrollbar = this.getAttribute("data-scrollbar") == "";
			this.freemode = this.getAttribute("data-freemode") == "";

			if (
				this.getAttribute("data-id") == "collection_recommendations" ||
				this.getAttribute("data-id") == "articles_pages"
			) {
				this.touchReleaseOnEdges = true;
				this.threshold = 5000;
			}

			this.nodes = {
				pagination: document.querySelectorAll(
					"[data-gallery-pagination='" + this.id + "']"
				),
			};
			this.manualInit = this.getAttribute("data-manual-init") === "";
			if (this.manualInit) return;
			this.init();
		}

		assignThumbs() {
			if (this.thumbs_id && this.thumbs_id !== "") {
				var wdn_thumbs = document.querySelector(
					"wdn-swiper[data-id='" + this.thumbs_id + "']"
				);
				if (!wdn_thumbs) {
					return;
				}

				this.thumbs = wdn_thumbs.Swiper;
			}
		}

		createSwiper() {
			if (this.isCreated) return;
			this.assignThumbs();
			this.isCreated = true;
			this.Swiper = new Swiper('wdn-swiper[data-id="' + this.id + '"]', {
				...(this.dataset.forceNav ? { threshold: 10 } : {}),
				loop: this.isLooped,
				centeredSlides: this.isCentered,
				touchStartPreventDefault: false,
				direction:
					this.direction && this.direction != ""
						? this.direction
						: "horizontal",
				speed: this.autoplay ? 10000 : 800,
				autoplay: {
					delay: this.autoplay ? 6000 : 0,
				},
				watchSlidesVisibility: true,
				watchSlidesProgress: true,
				freemode: this.freemode,
				pagination: {
					el: '[data-swiper-pagination="' + this.id + '"]',
					clickable: true,
					type: this.progressPagination ? "progressbar" : "bullets",
				},
				autoplay: {
					delay: this.autoplay ? 3000 : 0,
					enabled: this.autoplay,
				},
				navigation: {
					prevEl: '[data-swiper-prev="' + this.id + '"]',
					nextEl: '[data-swiper-next="' + this.id + '"]',
				},
				scrollbar: {
					el: ".swiper-scrollbar",
					hide: false,
				},
				lazy: {
					loadPrevNext: true,
				},
				breakpoints: {
					200: {
						slidesPerView:
							this.getSlidesPerView(2) || this.default.mobilePerView,
						centeredSlides: this.isCenteredOnMobile || this.isCentered,
						allowTouchMove: true,
						spaceBetween: this.getSpaceBetween(
							2,
							this.default.mobileSpaceBetween
						),
					},
					600: {
						slidesPerView:
							this.getSlidesPerView(1) || this.default.tabletPerView,
						spaceBetween: this.getSpaceBetween(
							1,
							this.default.tabletSpaceBetween
						),
						centeredSlides: this.isCentered,
						allowTouchMove: true,
					},
					1024: {
						slidesPerView: this.getSlidesPerView(0) || this.default.perView,
						spaceBetween: this.getSpaceBetween(0, this.default.spaceBetween),
						centeredSlides: this.isCentered,
						allowTouchMove: !this.isMobileOnly,
						slidesPerGroup: this.slidesPerGroup,
						autoplay: this.autoplay,
					},
				},
				thumbs: {
					swiper: this.thumbs || false,
				},
			});
			this.fireInitEvent();
		}

		fireInitEvent() {
			this.dispatchEvent(new CustomEvent("swiper:created", { detail: this }));
		}

		getSlidesPerView(index) {
			var data = this.perView[index];
			return data == "auto" ? data : parseFloat(data);
		}

		getSpaceBetween(index, _default) {
			var data = _default;
			if (typeof parseInt(this.spaceBetween[index]) === "number") {
				data = parseInt(this.spaceBetween[index]);
			}
			return data;
		}

		outputPagination() {
			if (this.nodes.pagination.length == 0) return;
			var active_index = this.Swiper.activeIndex + 1;
			var sum = this.Swiper.slides.length;
			this.nodes.pagination.forEach(function (container) {
				container.innerHTML = active_index + "/" + sum;
			});
		}
		setupCallbacks() {
			if (this.nodes.pagination.length == 0) return;
			this.Swiper.on("slideChange", this.onSlideChange.bind(this));
		}

		onSlideChange() {
			this.outputPagination();
		}

		init() {
			this.createSwiper();
			if (this.Swiper.autoplay && this.autoplay) {
				this.Swiper.autoplay.start();
			}
			this.setupCallbacks();
			this.outputPagination();
		}
	}

	customElements.define("wdn-swiper", WDNSwiper);
}

/* DRAWER/MODAL */
class WDNOverlay extends WDN.Component {
	constructor() {
		super();
		// Config
		this.config = {
			classes: {
				body_open: "overlay--open",
				open_vertical: "overlay--open-vertical",
				open_horizonal: "overlay--open-horizontal",
			},
			version: "1.1",
		};
		// Storing attributes
		this.id = this.getAttribute("data-id");
		this.isActive = this.getAttribute("data-active") == "";
		this.animate = this.getAttribute("data-animate");
		this.inner_div = this.querySelector("div");
		// Getting and storing type of the overlay (drawer,modal etc)
		var type = this.getAttribute("type") || "overlay";
		this.type = type;
		// setup of custom events names
		this.events = {
			open: type + ":opened",
			close: type + ":closed",
		};

		this.ignoreFade = this.getAttribute("data-ignore-fade") == "";

		// Event Callbacks
		this.closeOnKeyBound = this.closeOnKey.bind(this);
		this.closeOnClickBound = this.closeOnClick.bind(this);

		// INIT
		this.init();
	}

	active(newState) {
		if (newState) {
			this.setAttribute("data-active", "");
		} else {
			this.removeAttribute("data-active");
		}
		this.isActive = newState;
	}

	resetScrollPosition() {
		this.inner_div.scroll(0, 0);
	}

	setActive() {
		this.resetScrollPosition();
		this.active(true);
		this.appendActiveClasses();
	}

	setInactive() {
		this.active(false);
		this.removeActiveClasses();
	}

	open() {
		this.fireEvent({
			name: "overlay:close",
			target: document.body,
			detail: this,
		});
		// setting element as active
		this.setActive();
		// Bind window events
		this.bindWindowEvents();
		// fire custom event
		this.fireEvent({
			name: this.events.open,
			detail: this,
		});

		this.callback("onOpen");
	}

	close() {
		// clearing active state
		this.setInactive();
		// Unbind window events
		this.unbindWindowEvents();
		// fire custom events
		this.fireEvent({
			name: this.events.close,
			detail: this,
		});
		this.callback("onClose");
	}

	// listens for ESC key
	closeOnKey(e) {
		if (e.keyCode == 27) {
			this.close();
		}
	}

	// listens for outside click
	closeOnClick(e) {
		// first rule is for drawer, second one is for modal
		if (
			e.target === document.body ||
			(e.target === this && this.nodeName === "WDN-MODAL")
		) {
			this.close();
		}
	}

	// fires when element is opened
	bindWindowEvents() {
		this.bindElement(window, "keydown", this.closeOnKeyBound);
		this.bindElement(window, "click", this.closeOnClickBound);
	}
	// fires when element is closed
	unbindWindowEvents() {
		this.unbindElement(window, "keydown", this.closeOnKeyBound);
		this.unbindElement(window, "click", this.closeOnClickBound);
	}
	// fires when element is opened
	appendActiveClasses() {
		this.classList.add(this.currentAnimation);
		document.body.classList.add(this.config.classes.body_open);
	}
	// fires when element is closed
	removeActiveClasses() {
		this.classList.remove(this.currentAnimation);
		document.body.classList.remove(this.config.classes.body_open);
		if (!this.ignoreFade) {
			document.body.classList.add("overlay--open-fade-out");
			setTimeout(function () {
				document.body.classList.remove("overlay--open-fade-out");
			}, 200);
		}
	}

	setupAnimation() {
		// By default, overlay opens horizontally
		this.currentAnimation = this.config.classes.open_horizonal;
		if (this.animate === "top" || this.animate === "bottom") {
			this.currentAnimation = this.config.classes.open_vertical;
		}
	}

	onCloseEvent(e) {
		var detailID = e.detail ? e.detail.id : false;
		if (this.isActive) {
			// If we are in the search drawer and mobile quickshop called close - ignore
			if (this.id === "search" && detailID === "mobile_quickshop") return;

			/* prevent close of cart when special bfcm modal opens... */
			if (this.id === "cart" && detailID === "cart_bfcm_upsell") {
				var cartDrawer = document.querySelector('wdn-drawer[data-id="cart"]');
				document.body.classList.add('cart-bfcm-upsell--open');
				if (cartDrawer) {
					cartDrawer.classList.remove('modal-zindex');
				}

				return;
			}

			var default_fade = this.ignoreFade;
			this.ignoreFade = true;
			this.close();
			this.ignoreFade = default_fade;
		}
	}

	onOpenEvent(e) {
		if (!e.detail || e.detail.id != this.id || this.isActive) return;
		this.open();
	}

	listenForEvents() {
		this.bindElement(
			document.body,
			"overlay:close",
			this.onCloseEvent.bind(this)
		);
		this.bindElement(
			document.body,
			"overlay:open",
			this.onOpenEvent.bind(this)
		);
	}

	init() {
		this.listenForEvents();
		this.setupAnimation();
	}
}

/* UNIVERSAL DRAWER/MODAL TRIGGER  */
class WDNOverlayTrigger extends WDN.Component {
	constructor() {
		super();
		// drawer/modal id
		this.id = this.getAttribute("data-id");
		// actions - open, close
		this.action = this.getAttribute("action");
		// type can be modal, drawer etc
		this.type = this.getAttribute("type");
		// drawer/modal
		this.element = document.querySelector(
			"wdn-" + this.type + "[data-id='" + this.id + "']"
		);

		// INIT
		this.bind();
	}

	handleClick() {
		if (this.action === "close") {
			this.element.close();
			this.callback("onClose");
		}
		if (this.action === "open") {
			this.element.open();
			this.callback("onOpen");
		}
	}

	bind() {
		if (this.element) {
			this.addEventListener("click", this.handleClick.bind(this));
		}
	}
}

/* DRAWER CLOSER */
class WDNDrawerClose extends WDNOverlayTrigger {
	constructor() {
		super();
		this.element = document.querySelector(
			"wdn-drawer[data-id='" + this.id + "']"
		);
		this.action = "close";
		this.bind();
	}
}

/* MODAL CLOSER */
class WDNModalClose extends WDNOverlayTrigger {
	constructor() {
		super();
		this.element = document.querySelector(
			"wdn-modal[data-id='" + this.id + "']"
		);
		this.action = "close";
		this.bind();
	}
}

/* DRAWER OPENER */
class WDNDrawerOpen extends WDNOverlayTrigger {
	constructor() {
		super();
		this.element = document.querySelector(
			"wdn-drawer[data-id='" + this.id + "']"
		);
		this.action = "open";
		this.bind();
	}
}

/* MODAL OPENER  */
class WDNModalOpen extends WDNOverlayTrigger {
	constructor() {
		super();
		this.element = document.querySelector(
			"wdn-modal[data-id='" + this.id + "']"
		);
		this.action = "open";
		this.bind();
	}
}

class WDNModal extends WDNOverlay {
	constructor() {
		super();
		this.config.classes.body_open = "overlay--open";
	}
}

// Drawer/ Modal
customElements.define("wdn-overlay-trigger", WDNOverlayTrigger);
customElements.define("wdn-drawer", class extends WDNOverlay { });
customElements.define("wdn-modal", WDNModal);

// openers / closers
customElements.define("wdn-drawer-close", WDNDrawerClose);
customElements.define("wdn-modal-close", WDNModalClose);
customElements.define("wdn-drawer-open", WDNDrawerOpen);
customElements.define("wdn-modal-open", WDNModalOpen);

/* DROPDOWN */

class WDNDropdown extends WDN.Component {
	constructor() {
		super();
		this.id = this.getAttribute("data-id");
		this.config = {
			mobile_bp: 870,
		};
		this.isMobileOnly = this.getAttribute("data-mobileonly") == ""; // can trigger dropdown only on mobile
		this.visibleOnDesktop = this.getAttribute("data-desktop-visible") == ""; // dropdown opens itself on desktop screen
		this.shrinkOnDesktop = this.getAttribute("data-desktop-shrink") == ""; // collapses dropdown on large screen
		this.allow_preview = parseInt(this.getAttribute("data-allow-preview")) || 0;
		this.defaultToBeOpen = this.getAttribute("data-default-open") == "";
		this.disableAnimation = this.getAttribute("data-disable-animation") == "";
		this.buildConstructor();

		this.init();
	}

	configureAttributes() {
		this.nameSpace = this.getAttribute("data-name") || "dropdown";

		this.selectors = {
			trigger: "[" + this.nameSpace + "-trigger]",
			container: "[" + this.nameSpace + "-container]",
			content: "[" + this.nameSpace + "-content]",
		};

		this.attributeList = {
			group: "group",
			active: this.nameSpace + "-active",
		};
	}

	buildConstructor() {
		this.configureAttributes();
		this.triggers = this.querySelectorAll(this.selectors.trigger);
		this.container = this.querySelector(this.selectors.container);
		this.content = this.querySelector(this.selectors.content);
		this.group = this.getAttribute(this.attributeList.group);
		this.isActive = this.getAttribute(this.attributeList.active) === "";
	}

	setState(newState) {
		this.isActive = newState;
	}

	setContainerHeight(newHeight) {
		this.container.style.height = newHeight === "auto" ? newHeight : newHeight + "px";
	}

	shrinkContainer() {
		var height = this.allow_preview;
		this.setContainerHeight(height);
	}

	expandContainer() {
		if (!this.defaultToBeOpen) {
			this.setContainerHeight(this.disableAnimation ? "auto" : this.content.offsetHeight);
		}
	}

	setInactive() {
		this.setState(false);
		this.removeAttribute(this.attributeList.active);
		this.shrinkContainer();

		// this will help when extending the component
		if (typeof this.onClose === "function") {
			this.onClose();
		}
	}

	setActive() {
		this.collapseGroupContainers();
		this.setState(true);
		this.setAttribute(this.attributeList.active, "");
		this.expandContainer();

		// this will help when extending the component
		if (typeof this.onOpen === "function") {
			this.onOpen();
		}
	}

	fireGroupEvent() {
		var customEvent = new CustomEvent("dropdown:group:collapse", {
			detail: { group: this.group },
		});
		document.body.dispatchEvent(customEvent);
	}

	collapseGroupContainers() {
		if (this.group) {
			this.fireGroupEvent();
		}
	}

	onTriggerClick() {
		if (this.isMobileOnly && window.innerWidth > this.config.mobile_bp) return;
		if (this.isActive) {
			this.setInactive();
		} else {
			this.setActive();
		}

		if (typeof this.onClick === "function") {
			this.onClick();
		}
	}

	onWindowResize() {
		var isOnLargeScreen = window.innerWidth > this.config.mobile_bp;
		this.isActive ? this.expandContainer() : "";

		this.isMobileOnly ? this.setInactive() : "";
		this.visibleOnDesktop ? this.setActive() : "";
		this.shrinkOnDesktop ? this.setInactive() : "";
	}

	onGroupCollapse(e) {
		if (this.group === e.detail.group) {
			this.setInactive();
		}
	}

	setInitialState() {
		if (this.isActive) {
			this.expandContainer();
		}

		if (this.defaultToBeOpen) {
			this.setActive();
			this.defaultToBeOpen = false;
			this.expandContainer();
			setTimeout(() => {
				this.removeAttribute("data-default-open");
			}, 200);
		}
	}

	onOpenEvent(e) {
		var id = e.detail;
		if (id !== this.id) return;
		this.onTriggerClick();
	}

	bind() {
		this.triggers.forEach(function (trigger) {
			trigger.addEventListener("click", this.onTriggerClick.bind(this));
		}, this);

		document.body.addEventListener(
			"dropdown:open",
			this.onOpenEvent.bind(this)
		);
		document.body.addEventListener(
			"dropdown:group:collapse",
			this.onGroupCollapse.bind(this)
		);
		window.addEventListener("window:resize", this.onWindowResize.bind(this));
	}

	init() {
		this.setInitialState();
		this.bind();
	}
}
if (!customElements.get("wdn-dropdown")) {
	customElements.define("wdn-dropdown", WDNDropdown);
}

class WDNPopover extends WDNDropdown {
	buildConstructor() {
		super.buildConstructor();
		this.trigger = this.parentElement
			? this.parentElement.querySelector(
				'[data-popover-trigger="' + this.id + '"]'
			)
			: null;
		this.panel = this.querySelector("[popover-panel]");
		this.hoverActivate = this.trigger
			? this.trigger.hasAttribute("data-hover-activate")
			: false;
		this._hoverCloseTimer = null;
		this._hoverOpenTimer = null;
	}

	setInitialState() {
		super.setInitialState();
		this.updateAccessibilityState();
	}

	updateAccessibilityState() {
		if (this.trigger) {
			this.trigger.setAttribute("aria-expanded", String(this.isActive));
		}

		if (this.panel) {
			this.panel.setAttribute("aria-hidden", String(!this.isActive));
		}
	}

	onOpen() {
		this.updateAccessibilityState();
	}

	onClose() {
		this.updateAccessibilityState();
	}

	// Desktop only

	onDesktopOpen() {
		if (this.panel) {
			this.panel.focus();
		}
	}

	onPanelBlur() {
		this.setInactive();

		this.trigger.setAttribute("data-pointer-events-none", "");

		setTimeout(() => {
			this.trigger.removeAttribute("data-pointer-events-none");
		}, 500);
	}

	onPopoverTriggerClick() {
		if (this.isActive) {
			this.setInactive();
			return;
		}

		this.setActive();
		this.onDesktopOpen();
	}

	onDocumentClick(event) {
		if (!this.isActive) return;
		if (this.contains(event.target) || this.trigger.contains(event.target)) return;

		this.setInactive();
	}

	onKeyDown(event) {
		if (event.key !== "Escape" || !this.isActive) return;

		event.preventDefault();
		this.setInactive();
		this.trigger.focus();
	}

	onTriggerMouseEnter() {
		clearTimeout(this._hoverCloseTimer);
		if (this.isActive) return;
		this._hoverOpenTimer = setTimeout(() => {
			this.setActive();
			this.onDesktopOpen();
		}, 500);
	}

	onTriggerMouseLeave() {
		clearTimeout(this._hoverOpenTimer);
		this._hoverCloseTimer = setTimeout(() => {
			this.setInactive();
		}, 150);
	}

	onPanelMouseEnter() {
		clearTimeout(this._hoverCloseTimer);
	}

	onPanelMouseLeave() {
		this._hoverCloseTimer = setTimeout(() => {
			this.setInactive();
		}, 150);
	}

	// Mobile only

	onTriggerTouchEnd(event) {
		event.preventDefault();

		if (this.isActive) {
			this.setInactive();
			return;
		}

		this.setActive();
	}

	onDocumentTouch(event) {
		if (!this.isActive) return;
		if (this.contains(event.target) || this.trigger.contains(event.target)) return;

		this.setInactive();
	}

	bind() {
		super.bind();

		if (!this.trigger || !this.panel) return;

		this.panel.addEventListener("keydown", this.onKeyDown.bind(this));

		if ("ontouchstart" in window) {
			this.trigger.addEventListener("touchend", this.onTriggerTouchEnd.bind(this));
			document.addEventListener("touchstart", this.onDocumentTouch.bind(this));
		} else {
			this.trigger.addEventListener("click", this.onPopoverTriggerClick.bind(this));
			this.panel.addEventListener("blur", this.onPanelBlur.bind(this));
			document.addEventListener("click", this.onDocumentClick.bind(this));

			if (this.hoverActivate) {
				this.trigger.addEventListener("mouseenter", this.onTriggerMouseEnter.bind(this));
				this.trigger.addEventListener("mouseleave", this.onTriggerMouseLeave.bind(this));
				this.panel.addEventListener("mouseenter", this.onPanelMouseEnter.bind(this));
				this.panel.addEventListener("mouseleave", this.onPanelMouseLeave.bind(this));
			}
		}
	}
}

customElements.define("wdn-popover", WDNPopover);

/* EVENT EMITTER  */
/* EVENT EMITTER  */

class WDNEventEmitter extends WDN.Component {
	constructor() {
		super();

		this.data = {
			event: this.getAttribute("data-event"),
			target_selector: this.getAttribute("data-target"),
			detail: this.getAttribute("data-detail"),
		};

		this.init();
	}

	onClick() {
		var data = this.data;
		this.fireEvent({
			name: data.event,
			target: data.target,
			detail: data.detail,
		});
	}

	bind() {
		this.bindElement(this, "click", this.onClick.bind(this));
	}

	assignTarget() {
		var query = this.data.target_selector;
		if (!query || query == "") return;
		this.data.target = document.querySelector(query);
	}

	init() {
		this.assignTarget();
		this.bind();
	}
}

customElements.define("wdn-event-emitter", WDNEventEmitter);

class WDNVideoModalTrigger extends WDNModalOpen {
	constructor() {
		super();
		this.modal_iframe = this.element.querySelector("[data-modal-iframe]");
		this.video_src = this.getAttribute("data-video-src");
		this.embed_src = false;
		this.element.onClose = this.onClose.bind(this);
		this.isActive = false;
		this._init();
	}

	iframeHasAutoplayParam() {
		return this.modal_iframe.src.indexOf("?autoplay=1") > -1;
	}

	_play() {
		if (!this.isActive) return;
		if (!this.iframeHasAutoplayParam()) {
			this.modal_iframe.src = this.modal_iframe.src + "?autoplay=1&mute=0";
			this.isPlaying = true;
		}
	}

	_stop() {
		this.isPlaying = false;
		this.isActive = false;
		this.modal_iframe.src = this.embed_src;
	}

	appendEmbedSrc() {
		if (this.video_src === "" || this.modal_iframe.src === this.embed_src)
			return;
		this.modal_iframe.src = this.embed_src;
	}

	onClose() {
		this.isActive = false;
		this._stop();
	}

	onOpen() {
		this.isActive = true;
		this.loading(true, this.element);
		this.appendEmbedSrc();
		this.loading(false, this.element);
		this._play();
	}

	generateEmbedSrc() {
		if (this.isYoutube) {
			this.embed_src =
				"https://www.youtube.com/embed/" + this.video_src.split("?v=")[1];
		}
		if (this.isVimeo) {
			this.embed_src = this.video_src.replace(
				"vimeo.com/",
				"player.vimeo.com/video/"
			);
		}
	}

	assignVideoInfo() {
		if (this.video_src.indexOf("youtube") > -1) {
			this.isYoutube = true;
		} else if (this.video_src.indexOf("vimeo") > -1) {
			this.isVimeo = true;
		}
	}

	iframeOnLoad() {
		return;
		if (!this.isActive) return;
		this.loading(false, this.element);
		this._play();
	}

	_init() {
		this.assignVideoInfo();
		this.generateEmbedSrc();
		//   this.modal_iframe.addEventListener("load", this.iframeOnLoad.bind(this));
	}
}

customElements.define("video-modal-trigger", WDNVideoModalTrigger);

/* Article filters  */
/* Article filters  */

class WDNArticleFilter extends WDN.Component {
	constructor() {
		super();
		this.category = this.getAttribute("data-article-category");
		this.isActive = this.getAttribute("data-active") === "";
		this.blogId = this.getAttribute("data-for-blog");
		this.sharedFilters = this.getSharedFilters();
		this._init();
	}

	getSharedFilters() {
		var query =
			"wdn-article-filter[data-article-category='" +
			this.category +
			"'][data-for-blog='" +
			this.blogId +
			"']";
		return document.querySelectorAll(query);
	}

	setState(newState) {
		this.sharedFilters.forEach(function (filter) {
			if (newState) {
				filter.setAttribute("data-active", "");
			} else {
				filter.removeAttribute("data-active");
			}

			filter.isActive = newState;
		});
	}

	getActiveFilters() {
		var query =
			"wdn-article-filter[data-for-blog='" + this.blogId + "'][data-active]";
		return document.querySelectorAll(query);
	}

	getArticlesByCategory(category) {
		var query =
			"[data-article-card='" +
			category +
			"'][data-for-blog='" +
			this.blogId +
			"']";
		return document.querySelectorAll(query);
	}

	getCardsByBlogId(blogId) {
		var query = "[data-article-card][data-for-blog='" + blogId + "']";
		return document.querySelectorAll(query);
	}

	deselectActiveFilter() {
		var activeFilters = this.getActiveFilters();
		activeFilters.forEach(function (filter) {
			filter.setState(false);
		});
	}

	showAllArticles() {
		var sameCategoryArticles = this.getCardsByBlogId(this.blogId);
		sameCategoryArticles.forEach(function (article) {
			article.parentNode.classList.remove("hidden");
		});
	}

	hideAllArticles() {
		var sameCategoryArticles = this.getCardsByBlogId(this.blogId);

		sameCategoryArticles.forEach(function (article) {
			article.parentNode.classList.add("hidden");
		});
	}

	showArticleByCategory(category) {
		var articles = this.getArticlesByCategory(category);

		articles.forEach(function (article) {
			article.parentNode.classList.remove("hidden");
		});
	}

	onClick() {
		if (this.isActive) return;
		this.deselectActiveFilter();
		this.hideAllArticles();

		if (this.category === "all") {
			this.showAllArticles();
		} else {
			this.showArticleByCategory(this.category);
		}

		this.setState(true);
	}

	_init() {
		this.bindElement(this, "click", this.onClick.bind(this));
	}
}

customElements.define("wdn-article-filter", WDNArticleFilter);

/* Form validator */
/* Form validator */

class WDNFormValidator extends HTMLElement {
	constructor() {
		super();
		this.form = this.querySelector("form");
		this.requiredFields = this.querySelectorAll("[data-required]");
		this.init();
	}

	alertField(field) {
		field.parentNode.parentNode.setAttribute("data-state", "error");
	}
	removeAlert(field) {
		field.parentNode.parentNode.setAttribute("data-state", "default");
	}

	validateRequiredFields() {
		this.emptyFieldCount = 0;
		this.requiredFields.forEach(function (field) {
			var fieldIsEmpty = field.value == "";
			if (field.tagName == "WDN-SELECT") {
				fieldIsEmpty = !field.selected_option;
			}

			if (fieldIsEmpty) {
				this.emptyFieldCount = this.emptyFieldCount + 1;
				this.alertField(field);
			} else {
				this.removeAlert(field);
			}
		}, this);
	}

	submit() { }

	onFormSubmit(e) {
		e ? e.preventDefault() : false;
		this.validateRequiredFields();
		if (this.emptyFieldCount > 0) return;
		typeof this.submit === "function" ? this.submit() : false;
	}

	inputOnKeyDown(e) {
		var callback = this.validateRequiredFields.bind(this);
		var debounce = WDN.Debounce(callback, 300);
		debounce();
	}

	selectOnChange(e) {
		var select = e.detail;
		if (select.id !== "contact_reason") return;
		if (select.selected_option) {
			this.removeAlert(select);
		} else {
			this.alertField(select);
		}
	}

	bind() {
		this.inputOnKeyDownBound = this.inputOnKeyDown.bind(this);
		this.selectOnChangeBound = this.selectOnChange.bind(this);
		this.form.addEventListener("submit", this.onFormSubmit.bind(this));
		this.requiredFields.forEach(function (field) {
			if (field.tagName === "INPUT" || field.tagName === "TEXTAREA") {
				field.addEventListener("keydown", this.inputOnKeyDownBound);
			} else if (field.tagName === "WDN-SELECT") {
				document.body.addEventListener(
					"option:selected",
					this.selectOnChangeBound
				);
			}
		}, this);
	}

	init() {
		this.bind();
	}
}

customElements.define("wdn-form-validator", WDNFormValidator);

/* Progress bar */
/* Progress bar */
class WDNProgressBar extends WDN.Component {
	constructor() {
		super();
		this.id = this.getAttribute("data-id");
		this.bar = this.querySelector("[data-bar]");
		this.percentage = parseFloat(this.bar.style.width);
		this.init();
	}

	set(percentage) {
		percentage = percentage > 100 ? 100 : percentage;
		percentage = percentage < 0 ? 0 : percentage;
		this.percentage = percentage;
		this.bar.style.width = this.percentage + "%";
		this.callback("onSet");
	}

	onProgressSet(e) {
		var requested = e.detail;
		if (requested.id !== this.id) return;
		this.set(requested.percentage);
	}

	bind() {
		this.bindElement(
			document.body,
			"progress:set",
			this.onProgressSet.bind(this)
		);
	}
	init() {
		this.bind();
	}
}

customElements.define("wdn-progress", WDNProgressBar);

class WDNCheckbox extends WDN.Component {
	constructor() {
		super();
		this.id = this.getAttribute("data-id") || false;
		this.value = this.getAttribute("data-value");
		this.isChecked = this.getAttribute("data-checked") === "";
		this.isDisabled = this.getAttribute("data-disabled") === "";
		this.ghostCheckbox = this.querySelector('input[type="checkbox"]');
		this.mode = this.getAttribute("data-mode") || "checkbox";
		if (this.mode == "radio") {
			this.group_id = this.getAttribute("data-group");
		}
		this.init();
	}

	enable() {
		this.isDisabled = false;
		this.removeAttribute("data-disabled");
	}

	disable() {
		this.isDisabled = true;
		this.setAttribute("data-disabled", "");
	}

	setState(newState) {
		if (newState) {
			this.setAttribute("data-checked", "");
		} else {
			this.removeAttribute("data-checked");
		}
		this.ghostCheckbox.checked = newState;
		this.isChecked = newState;
	}

	getActiveRadio() {
		return document.querySelector(
			"wdn-checkbox[data-group='" + this.group_id + "'][data-checked]"
		);
	}

	clearActiveRadio() {
		var active_checkbox = this.getActiveRadio();
		if (!active_checkbox) return;
		active_checkbox.setState(false);
	}

	onClick() {
		if (this.isDisabled) return;
		if (this.mode == "radio") {
			this.clearActiveRadio();
			this.setState(true);
		} else {
			this.setState(!this.isChecked);
		}

		this.callback("onChange", this);
	}

	bind() {
		this.bindElement(this, "click", this.onClick.bind(this));
	}

	init() {
		this.bind();
	}
}

customElements.define("wdn-checkbox", WDNCheckbox);

// product
class BundleForm extends WDNProductForm {
	constructor() {
		super();
		this.noValidate = this.getAttribute("data-novalidate") === "";
		this.checkboxList = this.querySelectorAll("wdn-checkbox");
		this.sectionRenderer = this.querySelector("[data-section-renderer]");
		if (this.checkboxList.length === 0) {
			this.sectionRenderer.addEventListener(
				"sections:rendered",
				this.handleSectionRender.bind(this)
			);
			return;
		}

		this.setCallbacks();
	}

	handleSectionRender() {
		var renderedProducts = this.querySelectorAll("wdn-product-card");

		if (renderedProducts.length === 0) {
			this.closest(".shopify-section").classList.add("hidden");
			return;
		}

		this.checkboxList = this.querySelectorAll("wdn-checkbox");
		this.submitButton = this.querySelector('button[type="submit"]');
		this.setCallbacks();
	}

	onCheckboxChange() {
		if (this.noValidate) return;
		var activeCheckboxes = this.getActiveCheckboxes();
		this.submitButton.disabled = activeCheckboxes.length === 0;
	}

	getActiveCheckboxes() {
		return this.querySelectorAll("wdn-checkbox[data-checked]");
	}

	deselectCheckboxes() {
		var activeCheckboxes = this.getActiveCheckboxes();
		activeCheckboxes.forEach(function (checkbox) {
			if (checkbox.isChecked) {
				checkbox.setState(false);
			}
		}, this);
	}

	onAdd(res) {
		this.fireEvent({
			name: "product:added",
			detail: res,
		});
		if (this.checkboxList.length === 0) return;
		this.deselectCheckboxes();
		this.submitButton.disabled = true;
	}

	setCallbacks() {
		this.checkboxList.forEach(function (checkbox) {
			checkbox.onChange = this.onCheckboxChange.bind(this);
		}, this);
	}
}

customElements.define("wdn-bundle-form", BundleForm);

/* Horizontal dropdown  */

class WDNHorizontalDropdown extends WDNDropdown {
	constructor() {
		super();
	}
	setContainerWidth(newWidth) {
		this.container.style.width = newWidth + "px";
	}

	shrinkContainer() {
		this.trigger.remove();
	}

	expandContainer() { }
}
customElements.define("wdn-horizontal-dropdown", WDNHorizontalDropdown);

/* Product variations  */
class WDNProductVariations extends WDN.Component {
	constructor() {
		super();
		this.query = this.getAttribute("data-query");
		this.currentId = this.getAttribute("data-product-id");
		this.modal_container = document.querySelector("[data-modal-variations]");
		this.section_wrapper = document.querySelector(
			".section-variations-wrapper"
		);
		this.variations = [];
		this.isRendered = false;
		this.init();
	}

	onFetchError() {
		this.loading(false, this);
	}

	assignNewNodes() {
		var body_template = this.querySelector('[data-variations-layout="body"]');
		var modal_template = this.querySelector('[data-variations-layout="modal"]');
		if (body_template) {
			this.body_content = body_template.innerHTML;
		}
		if (modal_template) {
			this.modal_content = modal_template.innerHTML;
		}
		this.variation_count = parseInt(
			this.querySelector('[data-variations-config="count"]').innerHTML
		);
		this.variation_name = this.querySelector(
			"[data-variations-config='option_name']"
		).innerHTML;
	}

	getVariationValue(variation) {
		return variation.getAttribute("data-variant-option");
	}

	updateLayout() {
		if (!this.activeVariation) return;
		this.activeVariation.setAttribute("data-active", "");
		this.activeVariation.parentNode.parentNode.setAttribute("data-order", "-1");
		this.activeVariation.parentNode.parentNode.classList.remove("hidden");
		this.setActiveVariationValue(this.activeVariation_value);

		var visibleVariations = document.querySelectorAll(
			".product_variations-grid .variation-item:not(.hidden):not([data-order='-1']"
		);
		if (visibleVariations.length >= 3) {
			visibleVariations[visibleVariations.length - 1].classList.add("hidden");
		}
	}

	setActiveVariationValue(variation) {
		this.active_variation_container.innerHTML = variation;
	}

	onVariationHover(e) {
		this.setActiveVariationValue(this.getVariationValue(e.currentTarget));
	}

	onVariatioMouseOut() {
		this.setActiveVariationValue(this.activeVariation_value);
	}

	outputResponse(res) {
		var domParser = new DOMParser().parseFromString(res, "text/html");
		this.insertAdjacentHTML(
			"beforeend",
			domParser.querySelector(".shopify-section").innerHTML
		);
	}

	renderTemplates() {
		if (this.modal_container && this.modal_content) {
			this.modal_container.innerHTML = this.modal_content;
		}

		if (this.body_content) {
			this.innerHTML = this.body_content;
		}
	}

	assignActiveVariation() {
		this.variations = this.querySelectorAll("[data-product-variation]");
		this.active_variation_container = this.querySelector(
			"[data-active-option]"
		);
		this.activeVariation = this.querySelector(
			'[data-product-variation="' + this.currentId + '"]'
		);
		if (!this.activeVariation) return;
		this.activeVariation_value = this.getVariationValue(this.activeVariation);
	}

	assignOutputContainers() {
		this.name_containers = document.querySelectorAll("[data-variations-name]");
		this.count_containers = document.querySelectorAll(
			"[data-variations-count]"
		);
	}

	outputResultCount() {
		this.count_containers.forEach(function (container) {
			container.innerHTML = this.variation_count;
		}, this);
	}

	outputVariationName() {
		this.name_containers.forEach(function (container) {
			container.innerHTML = this.variation_name;
		}, this);
	}

	validateResponseCount() {
		if (this.variation_count > 0) return;
		this.section_wrapper.classList.add("hidden");
	}

	onFetchSuccess(res) {
		this.outputResponse(res);
		this.assignNewNodes();
		this.renderTemplates();
		this.validateResponseCount();
		this.assignOutputContainers();
		this.outputResultCount();
		this.outputVariationName();
		this.assignActiveVariation();
		this.updateLayout();
		this.loading(false, this);
		this.isRendered = true;
		this.bindElements(
			this.variations,
			"mouseover",
			this.onVariationHover.bind(this)
		);
		this.bindElements(
			this.variations,
			"mouseout",
			this.onVariatioMouseOut.bind(this)
		);
	}

	fetchVariations() {
		this.Request.Get({
			url:
				this.Routes.search_url +
				"?type=product&view=variations&q=" +
				this.query,
			onSuccess: this.onFetchSuccess.bind(this),
			onError: this.onFetchError.bind(this),
		});
	}

	init() {
		this.loading(true, this);
		this.fetchVariations();
	}
}

customElements.define("wdn-product-variations", WDNProductVariations);

class CardVariations extends WDN.Component {
	constructor() {
		super();
	}

	buildURL() {
		this.query = this.getAttribute("data-query");
		this.template = this.getAttribute("data-template") || "card-variations";
		this.productId = this.getAttribute("data-product-id");
		this.requestURL =
			this.Routes.search_url +
			"?type=product&view=" +
			this.template +
			"&q=" +
			this.query;
	}

	load() {
		if (this.loaded) {
			return;
		}

		// prevent refreshes for no reason
		this.loaded = true;
		this.buildURL();

		this.Request.Get({
			url: this.requestURL,
			onSuccess: (res) => {
				var htmlParser = new DOMParser();
				var parsedRes = htmlParser.parseFromString(res, "text/html");
				var sectionHTML = parsedRes.querySelector(".shopify-section");

				if (sectionHTML.children.length > 0) {
					var selfProduct = sectionHTML.querySelector(
						'[data-product-id="' + this.productId + '"]'
					);
					if (selfProduct) {
						selfProduct.remove();

						var resoultCountElem = sectionHTML.querySelector(
							"[data-result-count]"
						);
						var resoultCountValue = parseInt(
							resoultCountElem.getAttribute("data-result-count")
						);
						resoultCountElem.setAttribute(
							"data-result-count",
							resoultCountValue - 1
						);

						if (resoultCountValue > 5) {
							sectionHTML
								.querySelector(".variationsList")
								.classList.remove("jc:center");
						} else if (resoultCountValue <= 5) {
							sectionHTML
								.querySelector(".variationsList")
								.classList.add("jc:center");
						}
					}

					this.variationItems = sectionHTML.innerHTML;
					this.innerHTML = this.variationItems;
					this.setAttribute("data-loaded", "");
				} else {
				}
			},
			onError: (res) => { },
		});
	}

	onMouseOver() {
		this.load();
	}

	connectedCallback() {
		if (this.closest(".quickshop__card-variations__container")) {
			return;
		}

		this.load();
	}
}

customElements.define("card-variations", CardVariations);

class WDNQuantity extends WDN.Component {
	constructor() {
		super();
		/* Nodes */
		this.input = this.querySelector("[data-quantity-input]");
		this.increaseBtn = this.querySelector("[data-quantity-control='increase']");
		this.decreaseBtn = this.querySelector("[data-quantity-control='decrease']");
		/* Attributes  */
		this.id = this.getAttribute("id");
		this.min = this.input.getAttribute("min") || -999;
		this.min = parseInt(this.min); // parseInt on a new line because 0 == false and "0" == true
		this.max = parseInt(this.input.getAttribute("max")) || 999;
		this.value = parseInt(this.input.value);

		/* Init  */
		this.init();
	}

	// sets value of the input
	set(newValue) {
		newValue = parseInt(newValue);
		if (newValue > this.max) {
			newValue = this.max;
		}
		if (newValue < this.min) {
			newValue = this.min;
		}

		this.value = newValue;
		this.input.value = newValue;
		this.fireEvent({
			name: "quantity:change",
			detail: this,
		});
		this.validateQuantity();
		if (typeof this.onQuantityChange === "function") {
			if (!this.changeBound) {
				this.changeBound = WDN.Debounce(this.onQuantityChange, 180);
			}

			this.changeBound();
		}
	}

	// returns input value
	get() {
		return this.value;
	}

	// increases input value by 1
	increase() {
		var newValue = this.value + 1;
		if (newValue <= this.max) {
			this.set(newValue);
		}
		this.validateQuantity();
	}
	// decreases input value by 1
	decrease() {
		var newValue = this.value - 1;
		if (newValue >= this.min) {
			this.set(newValue);
		}
		this.validateQuantity();
	}

	inputIsValid() {
		var inputValue = this.input.value;
		return inputValue >= this.min && inputValue <= this.max;
	}

	// validates and updates input value
	inputOnChange() {
		// Validating if input value is in between min and max
		if (this.inputIsValid()) {
			this.set(this.input.value);
		}
	}

	bind() {
		this.bindElement(this.increaseBtn, "click", this.increase.bind(this));
		this.bindElement(this.decreaseBtn, "click", this.decrease.bind(this));
		this.bindElement(this.input, "change", this.inputOnChange.bind(this));
	}

	// disables increase button
	disableIncButton() {
		if (this.increaseBtn) {
			this.increaseBtn.disabled = true;
		}
	}
	// disables decrease button
	disableDecButton() {
		if (this.decreaseBtn) {
			this.decreaseBtn.disabled = true;
		}
	}

	// enables increase button
	enableIncButton() {
		if (this.increaseBtn) {
			this.increaseBtn.disabled = false;
		}
	}

	// enables decrease button
	enableDecButton() {
		if (this.decreaseBtn) {
			this.decreaseBtn.disabled = false;
		}
	}

	validateQuantity() {
		this.enableDecButton();
		this.enableIncButton();
		// checking if next values will go past min/max
		var incValue = this.value + 1;
		var decValue = this.value - 1;

		// disabling inccrease button
		if (incValue > this.max) {
			this.disableIncButton();
		}
		// disabling decrease button
		if (decValue < this.min) {
			this.disableDecButton();
		}
	}

	setInitialState() {
		this.validateQuantity();
	}

	init() {
		this.setInitialState();
		this.bind();
	}
}

customElements.define("wdn-quantity", WDNQuantity);

class WDNCartRemove extends WDN.Component {
	constructor() {
		super();
	}
}

customElements.define("wdn-cart-remove", WDNCartRemove);

/* WDN SCROLL */
/* WDN SCROLL */

class WDNScrollLink extends WDN.Component {
	constructor() {
		super();
		this.config = {
			scrollOffset: 90,
			headerHeight: parseInt(
				document.documentElement.style.getPropertyValue("--header-height")
			),
		};
		this.targetId = this.getAttribute("data-target");
		this.target = this.getTargetById(this.targetId);

		this.init();
	}

	getTargetById(id) {
		let target = document.querySelector(
			"wdn-scroll-target[data-id='" + id + "']"
		);

		if (!target) {
			target = document.querySelector("#" + id);
		}
		return target;
	}

	reached_bottom() {
		return window.innerHeight + window.scrollY >= document.body.offsetHeight;
	}

	reached_top() {
		return window.scrollY == 0;
	}

	getElementTopPosition(element) {
		return (
			element.getBoundingClientRect().top +
			window.pageYOffset -
			this.config.headerHeight
		);
	}

	scrollDown() {
		this.config.scrollOffset = this.getScrollOffset();
		var scrollTo = this.elementTopPos - 50;

		scroll({
			top: scrollTo,
			behavior: "smooth",
		});
	}

	getScrollOffset() {
		var offset = this.elementTopPos / 2;
		if (offset < 80) {
			offset = 400;
		}
		return offset;
	}

	scrollUp() {
		this.config.scrollOffset = this.getScrollOffset();
		this.isScrolling = true;
		var i = window.scrollY;
		this.Interval = setInterval(
			function () {
				window.scrollTo(0, i);
				i -= this.config.scrollOffset;
				if (i <= this.elementTopPos || this.reached_top()) {
					clearInterval(this.Interval);
					window.scrollTo(0, this.elementTopPos);
					this.isScrolling = false;
				}
			}.bind(this),
			20
		);
	}

	scrollTo(element) {
		if (!element || this.isScrolling) return;
		this.elementTopPos = this.getElementTopPosition(element);
		if (window.scrollY > this.elementTopPos) {
			this.scrollUp();
		} else {
			this.scrollDown();
		}
	}

	onClick(e) {
		e ? e.preventDefault() : "";
		this.scrollTo(this.target);
	}

	storeHeaderHeight() {
		this.config.headerHeight =
			parseInt(
				document.documentElement.style.getPropertyValue("--header-height")
			) || 0;
	}

	onHeaderHeightUpdate() {
		this.storeHeaderHeight();
	}

	bind() {
		this.bindElement(this, "click", this.onClick.bind(this));
		this.bindElement(
			document.body,
			"header_height:updated",
			this.onHeaderHeightUpdate.bind(this)
		);
	}
	init() {
		if (!this.target) return;
		this.bind();
	}
}

class WDNScrollTarget extends WDN.Component {
	constructor() {
		super();
	}
}

customElements.define("wdn-scroll-link", WDNScrollLink);
customElements.define("wdn-scroll-target", WDNScrollTarget);

class WDNLinkedDropdown extends WDNDropdown {
	constructor() {
		super();
		this.links = document.querySelectorAll(
			'[data-dropdown-link="' + this.id + '"]'
		);
		this.setLinksState("default");
	}

	setLinksState(newState) {
		this.links.forEach(function (link) {
			link.setAttribute("data-state", newState);
		}, this);
	}

	onOpen() {
		this.setLinksState("active");
	}

	onClose() {
		this.setLinksState("default");
	}
}

customElements.define("wdn-linked-dropdown", WDNLinkedDropdown);

class WDNTabs extends WDN.Component {
	constructor() {
		super();
		this.triggers = this.querySelectorAll("[data-tab-trigger]");
		this.activeTab = this.getActiveTab();
		this.init();
	}

	getActiveTab() {
		return (
			this.activeTab || this.querySelector("[data-tab-trigger][data-active]")
		);
	}
	getActiveId() {
		return this.activeTab ? this.getTabId(this.activeTab) : false;
	}

	getContentById(id) {
		return id ? this.querySelector("[data-tab-content='" + id + "']") : false;
	}

	getTabId(tab) {
		return tab ? tab.getAttribute("data-tab-trigger") : false;
	}

	clearActiveTab() {
		this.setInactive(this.activeTab);
	}

	setActive(tab) {
		if (!tab) return;
		tab.setAttribute("data-active", "");
		var content = this.getContentById(this.getTabId(tab));
		content.setAttribute("data-active", "");
		this.activeTab = tab;
	}

	setInactive(tab) {
		if (!tab) return;
		tab.removeAttribute("data-active");
		var content = this.getContentById(this.getTabId(tab));
		content.removeAttribute("data-active");
		this.activeTab = false;
	}

	triggerOnClick(e) {
		this.clearActiveTab();
		this.setActive(e.currentTarget);
	}

	bind() {
		this.bindElements(this.triggers, "click", this.triggerOnClick.bind(this));
	}

	setInitialState() {
		this.setActive(this.activeTab);
	}

	init() {
		this.setInitialState();
		this.bind();
	}
}
customElements.define("wdn-tabs", WDNTabs);

/* wdn select  */
/* wdn select  */

class WDNSelect extends WDN.Component {
	constructor() {
		super();
		this.id = this.getAttribute("data-id") || false;
		this.isActive = false;
		this.trigger = this.querySelector("[data-trigger]");
		this.placeholder = this.querySelector("[data-placeholder]");
		this.container = this.querySelector("[data-container]");
		this.content = this.querySelector("[data-content]");
		this.options = this.querySelectorAll("wdn-option");
		this.isDisabled = this.getAttribute("data-disabled") == "";
		this.selected_option = this.querySelector("wdn-option[data-selected]");
		this.noShrink = this.getAttribute("data-no-shrink") == "";
		this.has_default_option = this.getAttribute("data-single-option") == "";
		this.init();
	}

	setContainerHeight(newHeight) {
		this.container.style.height = newHeight + "px";
	}

	active(newState) {
		if (newState) {
			this.setAttribute("data-active", "");
		} else {
			this.removeAttribute("data-active");
		}

		this.isActive = newState;
	}

	expandContainer() {
		if (this.noShrink) return;
		this.active(true);
		this.setContainerHeight(this.content.offsetHeight);
		this.bindBody();
		this.callback("onExpand");
	}

	shrinkContainer() {
		if (this.noShrink) return;
		this.active(false);
		this.setContainerHeight(0);
		this.unbindBody();
		this.callback("onShrink");
	}

	clearActiveOption() {
		if (!this.selected_option) return;
		this.selected_option = !this.selected_option.deselect();
	}

	setTriggerState(newState) {
		if (!this.trigger) return;
		this.trigger.setAttribute("data-state", newState);
	}

	triggerOnClick() {
		if (this.isDisabled) return;
		if (this.has_default_option) {
			this.callback("onSingleOption");
			return;
		}
		if (this.isActive) {
			this.shrinkContainer();
		} else {
			this.expandContainer();
		}
	}

	getOptionByValue(reqValue) {
		var foundOption = false;
		this.options.forEach(function (option) {
			if (option.value == reqValue) {
				foundOption = option;
			}
		});

		return foundOption;
	}

	setActiveOptionByValue(value) {
		var requestedOption = this.getOptionByValue(value);
		if (!requestedOption) return;
		this.setActiveOption(requestedOption);
	}
	setActiveOption(option) {
		if (!option || option.isDisabled || option.value == "") return;
		this.clearActiveOption();
		this.selected_option = option.select();
		this.setPlaceholder(this.selected_option.label);
	}

	optionOnClick(e) {
		var option = e.currentTarget;
		this.setActiveOption(option);
		this.shrinkContainer();
		this.fireEvent({ name: "option:selected", detail: this });
		typeof this.onOptionSelect === "function"
			? this.onOptionSelect(this)
			: false;
	}

	setPlaceholder(newPlaceholder) {
		if (!this.placeholder) return;
		this.placeholder.innerHTML = newPlaceholder;
		this.placeholder_value = newPlaceholder;
	}

	bodyOnClick(e) {
		if (e.target.hasAttribute("data-pdp-form-submit")) {
			return;
		}

		if (!this.contains(e.target)) {
			this.shrinkContainer();
		}
	}

	bindBody() {
		this.bindElement(document.body, "click", this.bodyOnClickBound);
	}

	unbindBody() {
		this.unbindElement(document.body, "click", this.bodyOnClickBound);
	}

	onWindowResize() {
		if (this.isActive) {
			this.setContainerHeight(this.content.offsetHeight);
		}
	}

	bind() {
		this.bodyOnClickBound = this.bodyOnClick.bind(this);
		this.bindElement(window, "resize", this.onWindowResize.bind(this));
		this.bindElement(this.trigger, "click", this.triggerOnClick.bind(this));
		this.bindElements(this.options, "click", this.optionOnClick.bind(this));
	}

	setInitialState() {
		if (this.selected_option) {
			this.setPlaceholder(this.selected_option.label);
			if (!this.selected_option.label) {
				setTimeout(
					function () {
						this.setPlaceholder(this.selected_option.label);
					}.bind(this),
					200
				);
			}
		}
	}

	init() {
		this.setInitialState();
		this.bind();
	}
}

class WDNOption extends WDN.Component {
	constructor() {
		super();
		this.value = this.getAttribute("data-value");
		this.label = this.getAttribute("data-label");
		this.isSelected = this.getAttribute("data-selected") == "";
		this.isDisabled = this.getAttribute("data-disabled") == "";
		this.init();
	}

	enable() {
		this.isDisabled = false;
		this.removeAttribute("data-disabled");
	}

	disable() {
		this.isDisabled = true;
		this.setAttribute("data-disabled", "");
	}

	select() {
		this.isSelected = true;
		this.setAttribute("data-selected", "");
		return this;
	}

	deselect() {
		this.isSelected = false;
		this.removeAttribute("data-selected");
		return this;
	}

	init() {
		//
	}
}

class WDNVariantSelect extends WDNSelect {
	constructor() {
		super();
		this.handle = this.getAttribute("data-handle") || false;
		this.sharedSelects = document.querySelectorAll(
			"[data-select][data-id='" + this.id + "']"
		);
		this.variantDump = document.querySelector(
			"[data-variant-dump='" + this.id + "']"
		);
		this.stockDump = document.querySelector(
			"[data-variant-stock='" + this.id + "']"
		);
		this.ghostSelectInput = document.querySelector(
			"[data-ghost-select='" + this.id + "']"
		);
		this.submitButton = document.querySelector(
			"[data-form-submit='" + this.id + "']"
		);
		this.compare_priceContainers = document.querySelectorAll(
			"[data-compareprice-for='" + this.id + "']"
		);
		this.priceContainers = document.querySelectorAll(
			"[data-price-for='" + this.id + "']"
		);
		this.titleContainers = document.querySelectorAll(
			"[data-title-for='" + this.id + "']"
		);
		this.form = document.querySelector('[data-form="' + this.id + '"]');
		this.isProductPage =
			this.getAttribute("data-productpage") === "" ||
			this.classList.contains("select--product_page");
		this.variants = JSON.parse(this.variantDump.innerText);
		this.stock_json = JSON.parse(this.stockDump.innerText);
		this.selectedOptions = [];
		this.selectedVariant = false;
		this.selectedVariant_stock = false;
		this.isQuickshop = this.classList.contains("select--quickshop");
		this.wishlist = document.querySelector(
			"wishlist-trigger[data-product-handle='" + this.handle + "']"
		);
		this.start();

		this.hasAnyPreorders = false;

		this.variants.forEach((elem) => {
			if (this.stock_json[elem.title]) {
				if (this.stock_json[elem.title].status == "preorder") {
					this.hasAnyPreorders = true;
				}
			}
		});

		if (this.hasAnyPreorders) {
			if (this.closest(".cart-recommended-item")) {
				this.closest(".cart-recommended-item").remove();
			}
		}

		this.validateOptionsQty();
		this._setInitialState();
	}

	updateVariantTitles() {
		if (!this.selectedVariant) return;
		var title =
			this.selectedVariant.title == "Default Title"
				? ""
				: this.selectedVariant.title;
		this.titleContainers.forEach(function (container) {
			container.innerHTML = title;
		}, this);
	}

	_setInitialState() {
		if (!this.selected_option || !this.selectedVariant.available) {
			this.disableSubmit();
		}
	}

	setSubmitState(newState) {
		if (!this.submitButton) return;
		this.submitButton.setAttribute("data-state", newState);
	}

	storeSelections() {
		this.selectedOptions = [];
		this.sharedSelects.forEach(function (select) {
			if (select.selected_option) {
				this.selectedOptions.push(select.selected_option.value);
			}
		}, this);
	}

	/**
	 *
	 * @param {array} options
	 */
	getSelectedVariant() {
		var joinedOptions = this.selectedOptions.join(" / ");
		for (var i = 0; i < this.variants.length; i++) {
			if (joinedOptions == this.variants[i].title) {
				return this.variants[i];
			}
		}
	}

	storeSelectedVariant() {
		var selectedVariant = this.getSelectedVariant();
		this.sharedSelects.forEach(function (select) {
			select.selectedVariant = selectedVariant;
			select.selectedVariant_stock = selectedVariant
				? select.stock_json[selectedVariant.title]
				: false;
		}, this);
	}

	storeData() {
		this.storeSelections();
		this.getSelectedVariant();
		this.storeSelectedVariant();
	}

	updateGhostSelectInput() {
		this.ghostSelectInput.value = this.selectedVariant.id;

		try {
			this.ghostSelectInput.dispatchEvent(new CustomEvent("variant:changed", { detail: this.selectedVariant }));
		} catch (e) {
			console.error(e)
		}
	}

	disableSubmit() {
		if (!this.submitButton) return;
		this.submitButton.disabled = true;
	}

	enableSubmit() {
		if (!this.submitButton) return;
		this.submitButton.disabled = false;
	}

	updatePrices() {
		var isOnSale = this.variantIsOnSale();
		this.priceContainers.forEach(function (container) {
			container.innerHTML = WDN.Money.Format(this.selectedVariant.price);
			if (isOnSale) {
				container.setAttribute("data-on-sale", "");
			} else {
				container.removeAttribute("data-on-sale");
			}
		}, this);
	}

	variantIsOnSale() {
		return this.selectedVariant.compare_at_price > this.selectedVariant.price;
	}

	updateComparePrices() {
		var isOnSale = this.variantIsOnSale();
		this.compare_priceContainers.forEach(function (container) {
			container.innerHTML = isOnSale
				? WDN.Money.Format(this.selectedVariant.compare_at_price)
				: "";
		}, this);
	}

	setControlsState(newState) {
		this.stockState = newState;
		this.setSubmitState(newState);
		this.setTriggerState(newState);
	}

	updateProductCardPreorderLabels() {
		if (this.selected_option) {
			if (this.selected_option.getAttribute("data-preorder")) {
				var activePreorderweek =
					this.selected_option.getAttribute("data-preorder");
				this.querySelectorAll("[data-preorder-week]").forEach((elem) => {
					elem.innerText = activePreorderweek;
				});
			}
		}
	}

	validateSelection() {
		if (!this.selectedVariant) {
			this.disableSubmit();
			this.setControlsState("blank");
			return;
		}
		this.updateGhostSelectInput();
		this.updateVariantTitles();
		this.updatePrices();
		this.updateComparePrices();

		if (this.selected_option.hasAttribute("data-preorder")) {
			this.setControlsState("preorder");
			this.updateProductCardPreorderLabels();
			this.enableSubmit();
		} else {
			if (
				this.selectedVariant.available &&
				this.selectedVariant_stock.count > 0
			) {
				this.setControlsState("default");
				this.enableSubmit();
			} else {
				this.setControlsState("sold_out");
				this.disableSubmit();
			}
		}
	}

	getState() {
		var state = "blank";
		if (!this.selectedVariant) {
			return state;
		}
		if (
			this.selectedVariant.available &&
			this.selectedVariant_stock.count > 0
		) {
			state = "default";
		} else {
			state = "sold_out";
		}
		return state;
	}

	onOptionSelect() {
		this.storeData();
		this.validateSelection();

		this.sharedSelects.forEach(function (select) {
			select.fireEvent({ name: "variant:selected", detail: select });
			select.callback("onVariantChange");
		}, this);

		if (!this.selectedVariant) return;

		// Update wishlist's variant id, price - for tracking purposes
		if (this.wishlist) {
			this.wishlist.setAttribute("data-variant-id", this.selectedVariant.id);
			this.wishlist.setAttribute(
				"data-variant-price",
				WDN.Money.Format(this.selectedVariant.price)
			);
			this.wishlist.setAttribute(
				"data-variant-compareprice",
				WDN.Money.Format(this.selectedVariant.compare_at_price || 0)
			);
		}

		// Logic for redirecting to product below
		if (this.selectedVariant.available) return;

		// If on product page - close select
		if (this.isProductPage) {
			var selectModal = document.querySelector(
				"wdn-modal[data-id='mobile_variant_select']"
			);
			if (!selectModal) return;
			selectModal.isActive ? selectModal.close() : false;
			return;
		}

		// If is quickshop and variant not available - redirect
		if (!this.isQuickshop || !this.handle) return;

		window.location.href =
			Shopify.routes.root +
			"products/" +
			this.handle +
			"?variant=" +
			this.selectedVariant.id;
	}

	start() {
		setTimeout(
			function () {
				this.storeData();
				this.validateSelection();
				this.fireEvent({ name: "variant_select:initted", detail: this });
				this.callback("onInit");
				this.classList.add("select--initialized");
			}.bind(this),
			500
		);
	}

	validateOptionsQty() {
		if (this.has_default_option && this.trigger) {
			this.trigger.classList.add("events-none");
		}
	}
}

class WDNAddonSelect extends WDNSelect {
	constructor() {
		super();

		// Note: the below inputs are defined on the desktop version.
		// Make sure future updates acknowledge this when handling
		// the mobile version.

		this.hiddenInput = this.querySelector(
			"[name='items[Addon]id']"
		);
		this.hiddenQtyInput = this.querySelector(
			"[name='items[Addon]quantity']"
		);
		this.hiddenMainProductIdInput = this.querySelector(
			"[name='items[Addon]parent_id']"
		);
		this.metaobjectIdInput = this.querySelector("[name='items[Addon]properties[_addon_option_id]']");

		this.addonPrice = Number(this.getAttribute("data-price") || 0);
		this.addonComparePrice = Number(this.getAttribute("data-compare-at-price") || 0);

		try {
			this.comparePriceMap = JSON.parse(this.getAttribute("data-compare-at-price-json") || "{}");
		} catch (error) {
			this.comparePriceMap = {};
		}

		try {
			this.bulkDiscountData = JSON.parse(this.getAttribute("data-bulk-discount-json") || "{}");
		} catch (error) {
			console.error(error)
		}

		// We have to fire this callback to have ProductPage
		// handle all updates. Because the whole logic is too
		// messed up and it's best to have that class handle it.
		this.setTriggerState("blank");
		this.callback("onVariantChange");

		document.body.addEventListener(
			"quantity:change",
			function (e) {
				if (this.hiddenQtyInput && e.detail) {
					this.hiddenQtyInput.value = e.detail.value;
				}
			}.bind(this)
		);

		const ghostIdInput = document.querySelector(
			"[data-ghost-select='product_page']"
		);
		if (ghostIdInput) {
			ghostIdInput.addEventListener(
				"variant:changed",
				this.onMainVariantChange.bind(this)
			);
		}
	}

	getComparePriceForVariant(variantId) {
		if (variantId && this.comparePriceMap[variantId] !== undefined) {
			return this.comparePriceMap[variantId];
		}
		return this.addonComparePrice;
	}

	onOptionSelect() {
		this.callback("onVariantChange");
		const choseAddon = this.selected_option.getAttribute("data-value") === "with-addon";
		if (this.hiddenInput) {
			this.hiddenInput.disabled = !choseAddon;
		}
		if (this.hiddenQtyInput) {
			this.hiddenQtyInput.disabled = !choseAddon;
		}
		if (this.hiddenMainProductIdInput) {
			this.hiddenMainProductIdInput.disabled = !choseAddon;
		}
		if (this.metaobjectIdInput) {
			this.metaobjectIdInput.disabled = !choseAddon;
		}
	}

	onMainVariantChange(e) {
		const mainVariantId = e?.detail?.id;
		if (!this.hiddenMainProductIdInput) {
			return
		}
		if (!mainVariantId) {
			// Deleting just to be sure
			this.hiddenMainProductIdInput.remove();
			return;
		}
		this.hiddenMainProductIdInput.value = mainVariantId;
	}
}

class WDNAddOn extends WDNVariantSelect {
	constructor() {
		super();

		this.optionsCount = Number(this.getAttribute("data-options-count") || "1");
		if (this.optionsCount < 1) this.optionsCount = 1;

		this.optionGroups = this.querySelectorAll("[data-option-index]");
		this.activeOptionIndex = 0;

		this.optionGroups.forEach((group) => {
			const index = Number(group.getAttribute("data-option-index"));
			if (index !== 0) {
				group.classList.add("hidden")
			}
		});

		if (
			this.stock_json["Default Title"] &&
			this.stock_json["Default Title"].count == 0
		) {
			if (!this.stock_json.status == "preorder") {
				this.setTriggerState("sold_out");
			}
		}
	}

	validateOptionsQty() {
		return;
	}

	onSingleOption() {
		if (this.selectedVariant) {
			this.handleSubmit();
		} else {
			this.expandContainer();
		}
	}

	onExpand() {
		this.setTriggerState("active");
	}

	onShrink() {
		this.setTriggerState("default");
	}

	bodyOnClick(e) {
		if (this.hasAttribute("data-step-lock")) {
			const addonCard = this.closest(".card--add_on");
			if (addonCard && addonCard.contains(e.target)) {
				return;
			}
		}

		super.bodyOnClick(e);
	}

	deselectActiveOption() {
		if (this.options.length < 2) return;
		this.selected_option.deselect();
	}

	formOnAdd() {
		this.setTriggerState("success");
		setTimeout(
			function () {
				this.setTriggerState("default");
				this.deselectActiveOption();
			}.bind(this),
			1200
		);
	}

	reAssignForm() {
		this.form = document.querySelector('[data-form="' + this.id + '"]');
		this.form.onAdd = this.formOnAdd.bind(this);
	}

	handleSubmit(cb) {
		if (this.closest("search-product-card")) {
			if (this.selected_option.hasAttribute("data-preorder")) {
				window.location.href =
					Shopify.routes.root +
					"products/" +
					this.closest("search-product-card").getAttribute("data-handle") +
					"?variant=" +
					this.selectedVariant.id;
				return;
			}
		}

		if (this.selectedVariant && this.selectedVariant.available) {
			this.setTriggerState("loading");
			this.reAssignForm();
			this.form._submit(cb);
		}
	}

	onVariantChange() {
		const steps = this.closest("wdn-addon-steps");
		if (!steps) return;

		const index = Number(this.getAttribute("data-option-index"));
		const isLast = index === steps?.items?.length - 1;

		if (!isLast) return;
		this.handleSubmit();
	}
}

class WDNAddonSteps extends HTMLElement {
	connectedCallback() {
		this.items = [...this.querySelectorAll("[data-option-index]")];

		if (this.items.length <= 1) return;

		this.activeIndex = 0;

		this.items.forEach((el, i) => {
			if (i !== 0) {
				el.classList.add("hidden");
			}

			const backBtn = el.querySelector("[data-addon-back]");
			if (backBtn) {
				backBtn.addEventListener("click", () => {
					this.goBack();
				});
			}
		});

		this._onOptionSelected = this.onOptionSelected.bind(this);
		document.body.addEventListener("option:selected", this._onOptionSelected);
	}

	onOptionSelected(e) {
		const stepEl = e.detail;
		if (!stepEl || !this.contains(stepEl)) return;

		// if (stepEl.hasAttribute("data-single-option")) {
		// 	if (typeof stepEl.handleSubmit === "function") {
		// 		stepEl.handleSubmit();
		// 	}
		// 	return;
		// }

		const index = Number(stepEl.getAttribute("data-option-index"));
		if (index !== this.activeIndex) return;

		const current = this.items[index];
		const next = this.items[index + 1];

		if (!next) {
			stepEl.handleSubmit(this.reset.bind(this));
			return;
		}

		current.classList.add("hidden");
		current.removeAttribute("data-step-lock");

		next.classList.remove("hidden");
		next.setAttribute("data-step-lock", "");

		this.activeIndex++;

		next.expandContainer();
	}

	reset() {
		this.items.forEach((el, i) => {
			el.removeAttribute("data-step-lock");
			if (i === 0) el.classList.remove("hidden");
			else el.classList.add("hidden");

			el.shrinkContainer();
		});

		this.activeIndex = 0;
	}

	goBack() {
		if (this.activeIndex === 0) return;

		const current = this.items[this.activeIndex];
		const prev = this.items[this.activeIndex - 1];

		current.classList.add("hidden");
		current.removeAttribute("data-step-lock");

		prev.classList.remove("hidden");
		prev.setAttribute("data-step-lock", "");

		this.activeIndex--;

		prev.expandContainer();
	}

	disconnectedCallback() {
		document.body.removeEventListener("option:selected", this._onOptionSelected);
	}

	resetLocks() {
		this.items.forEach(el => {
			el.removeAttribute("data-step-lock");
		});
	}
}


class WDNProductCard extends WDN.Component {
	constructor() {
		super();
		this.product_id = this.getAttribute("data-id");
		this.Quickshop = this.querySelector("wdn-quickshop");
		this.ProductSwiper = this.querySelector("wdn-product-swiper");
		this.productURL = this.getAttribute("data-relative-product-url");
		this.CardVariations = this.querySelector(
			".quickshop__card-variations__container card-variations"
		);

		if (this.getAttribute("data-has-gallery") == "false") {
			this.ProductSwiper = null;
		}

		if (window.innerWidth < 560) {
			this.ProductSwiper = null;
		}

		this.init();
	}

	validateRequests() {
		if (this.isRendered) return;

		if (this.Quickshop) {
			this.isRendered = this.Quickshop.isRendered;
		}

		if (this.ProductSwiper) {
			this.isRendered = this.ProductSwiper.isRendered;
		}

		if (this.isRendered) {
			this.setAttribute("data-card-loaded", "");
		}
	}

	onElementRender() {
		this.validateRequests();
	}

	onMouseOver() {
		if (window.innerWidth < 880 || this.isRendered) return;
		this.Quickshop ? this.Quickshop.onMouseOver() : "";
		this.ProductSwiper ? this.ProductSwiper.onMouseOver() : "";
		this.CardVariations ? this.CardVariations.onMouseOver() : "";
		this.validateRequests();
	}

	onMouseLeave() {
		if (window.innerWidth > 880) {
			this.Quickshop ? this.Quickshop.onMouseLeave() : "";
		}
	}

	setupCallbacks() {
		if (this.ProductSwiper) {
			this.ProductSwiper.onRender = this.onElementRender.bind(this);
		}

		if (this.Quickshop) {
			this.Quickshop.onRender = this.onElementRender.bind(this);
			this.Quickshop.product_card = this;
			this.Quickshop.parent_container = this.parent_container;
		}
	}

	bind() {
		this.bindElement(this, "mouseover", this.onMouseOver.bind(this));
		this.bindElement(this, "mouseleave", this.onMouseLeave.bind(this));
	}

	init() {
		this.setupCallbacks();
		this.bind();
	}
}

class WDNProductSwiper extends WDN.Component {
	constructor() {
		super();
		this.productHandle = this.getAttribute("data-product-handle");
		this.productURL = this.getAttribute("data-relative-product-url");
		this.isRendered = false;
	}

	onFetch(res) {
		this.responseHTML = new DOMParser()
			.parseFromString(res, "text/html")
			.querySelector("wdn-swiper");
		this.isRendered = true;
		this.isFetching = false;
		this.querySelector(
			"[data-product-gallery-placeholder]"
		).insertAdjacentElement("afterEnd", this.responseHTML);
		this.loading(false, this);
		this.callback("onRender");
	}

	onFetchError() {
		this.isFetching = false;
		this.loading(false, this);
	}

	fetchSwiper() {
		if (this.isFetching) return;
		this.isFetching = true;

		this.endpoint =
			this.productURL + "?section_id=template-product-card-swiper";

		this.Request.Get({
			url: this.endpoint,
			onSuccess: this.onFetch.bind(this),
			onError: this.onFetchError.bind(this),
		});
	}

	onMouseOver() {
		if (this.isRendered) return;
		this.loading(true, this);
		this.fetchSwiper();
	}
}

class WDNQuickshop extends WDN.Component {
	constructor() {
		super();
		this.productId = this.getAttribute("data-id");
		this.productHandle = this.getAttribute("data-product-handle");
		this.productURL = this.getAttribute("data-relative-product-url");
		this.isRendered = false;
		this.variantJSON = false;
		this.variantSelect = false;
	}

	onExpand() {
		this.setParentActiveAttribute(true);
		this.variantSelect.setTriggerState("active");
	}

	onShrink() {
		var selectedVariant = this.variantSelect.selectedVariant;
		var state = "default";

		if (!selectedVariant) {
			state = "blank";
		}
		this.variantSelect.setTriggerState(state);
	}

	setParentActiveAttribute(state) {
		if (state) {
			this.setAttribute("data-quickshop-active", "");
		} else {
			this.removeAttribute("data-quickshop-active");
		}
	}

	onSubmitClick() { }

	assignNewNodes() {
		this.variantSelect = this.querySelector("wdn-quickshop-variant-select");
		if (!this.variantSelect) return;
		this.closers = this.querySelectorAll("[data-quickshop-close]");
		this.variantSelect.sharedSelects = this.querySelectorAll(".select");
		this.variantSelect.onExpand = this.onExpand.bind(this);
		this.variantSelect.onShrink = this.onShrink.bind(this);
		this.variantJSON = JSON.parse(
			this.querySelector("[data-variant-dump]").innerText
		);
	}

	bindNewNodes() {
		if (!this.closers) return;
		this.bindElements(this.closers, "click", this.closerOnClick.bind(this));
	}

	onFetch(res) {
		this.isRendered = true;
		this.isFetching = false;
		this.removeAttribute("data-fetching");
		this.innerHTML = res;
		this.assignNewNodes();
		this.bindNewNodes();
		this.loading(false, this);
		this.fireEvent({ name: "quickshop:fetched", detail: this });
		this.callback("onRender");
	}

	onFetchError() {
		this.loading(false, this);
		this.isFetching = false;
		this.removeAttribute("data-fetching");
	}

	fetchQuickshop() {
		if (this.isFetching) return;
		this.isFetching = true;
		this.setAttribute("data-fetching", "");
		this.endpoint = this.productURL + "?section_id=template-quickshop";

		this.Request.Get({
			url: this.endpoint,
			onSuccess: this.onFetch.bind(this),
			onError: this.onFetchError.bind(this),
		});
	}

	onMouseOver() {
		if (this.isRendered) return;
		this.loading(true, this);
		this.fetchQuickshop();
	}

	onMouseLeave() {
		this.querySelectorAll("wdn-quickshop-variant-select").forEach(vs => vs.shrinkContainer());
	}

	closerOnClick() {
		if (!this.variantSelect) return;
		this.variantSelect.shrinkContainer();
	}
}

class WDNQuickshopTrigger extends WDN.Component {
	constructor() {
		super();
		this.id = this.getAttribute("data-id");
		this.Quickshop = document.querySelector(
			"wdn-quickshop[data-id='" + this.id + "']"
		);
		this.state = false;
		this.init();
	}

	setPosition(newPosition) {
		this.position = newPosition;
		this.Quickshop.setAttribute("data-position", newPosition);
	}

	pushQuickshop() {
		if (this.position == "push") return;
		this.setPosition("push");
		if (this.options_length > 1) {
			this.Quickshop.variantSelect.shrinkContainer();
		} else {
		}
		this.Quickshop.setParentActiveAttribute(false);
		this.unbindBody();
	}

	pullQuickshop() {
		if (this.position == "pull") return;
		this.setPosition("pull");
		if (this.options_length > 1) {
			this.Quickshop.variantSelect.expandContainer();
		} else {
		}
		this.Quickshop.setParentActiveAttribute(true);
		this.bindBody();
	}

	bindBody() {
		setTimeout(
			function () {
				this.bindElement(document.body, "click", this.bodyOnClickBound);
			}.bind(this),
			500
		);
	}
	unbindBody() {
		this.unbindElement(document.body, "click", this.bodyOnClickBound);
	}

	bodyOnClick(e) {
		if (this.Quickshop.contains(e.target)) return;
		this.pushQuickshop();
	}

	onQuickShopRender(e) {
		if (window.innerWidth > 880 || e.detail !== this.Quickshop) return; // stop function if on a large screen

		this.Quickshop.variantSelect.bodyOnClickBound = function () { };
		this.options_length = this.Quickshop.variantSelect.options.length;
		this.Quickshop.product_card.setAttribute("data-quickshop-rendered", "");
		this.pullQuickshop();
	}

	onClick() {
		if (this.Quickshop.isRendered) {
			this.pullQuickshop();
		} else {
			this.Quickshop.fetchQuickshop();
		}
	}

	bind() {
		this.bindElement(
			document.body,
			"quickshop:fetched",
			this.onQuickShopRender.bind(this)
		);
		this.bindElement(this, "click", this.onClick.bind(this));
	}

	init() {
		this.bodyOnClickBound = this.bodyOnClick.bind(this);
		this.bind();
	}
}

if (!customElements.get("wdn-quickshop-mobile-trigger")) {
	class WDNMobileQuickshop extends WDN.Component {
		constructor() {
			super();
			this.sectionToRender = "quickshop-mobile";
			this.productSrc = this.getAttribute("data-product-url");
			this.paramChar = this.productSrc.indexOf("?") > -1 ? "&" : "?";
			this.endpoint =
				this.productSrc + this.paramChar + "section_id=" + this.sectionToRender;
			this.modal = document.querySelector(
				'wdn-modal[data-id="mobile_quickshop"]'
			);
			this.outputTarget = this.modal.querySelector("[data-quickshop-mobile]");
			this.preventCartDrawer = this.getAttribute("data-prevent-drawer") === "";
			this.maintainStateOnAdd =
				this.getAttribute("data-maintain-state-onadd") === "";
			this.isSearchResultItem = false;
			this.mount();
		}

		loadContent(req_config) {
			WDN.Request.Get(req_config);
		}

		loadQuickshop() {
			this.loadContent({
				url: this.endpoint,
				onSuccess: function (res) {
					// If prevent cartDrawer - use DOM parser and set attribute on <wdn-product-form>
					if (this.preventCartDrawer) {
						var domParser = new DOMParser();
						var parsedResponse = domParser.parseFromString(res, "text/html");
						var formElement = parsedResponse.querySelector("wdn-product-form");

						if (formElement) {
							formElement.setAttribute("data-prevent-drawer", "");
							formElement.setAttribute("data-close-quickshop-onadd", "");
						}

						this.outputTarget.innerHTML = "";
						this.outputTarget.appendChild(
							parsedResponse.querySelector(".shopify-section")
						);
					} else {
						this.outputTarget.innerHTML = res;
					}

					this.modal.open();

					if (!this.maintainStateOnAdd) return;

					var form = this.modal.querySelector("wdn-product-form");
					if (!form) return;
					if (typeof form.onAdd === "function") return;

					form.onAdd = function () {
						this.setAttribute("data-state", "success");
					}.bind(this);
				}.bind(this),
				onError: function (r) { },
			});
		}

		handleClick() {
			if (!this.quickshopLoaded) {
				this.loadQuickshop();
			}
		}

		addEventListeners() {
			this.addEventListener("click", this.handleClick.bind(this));
		}

		mount() {
			this.addEventListeners();
		}
	}

	customElements.define("wdn-quickshop-mobile-trigger", WDNMobileQuickshop);
}

if (!customElements.get("cart-bfcm-upsell-mobile")) {
	class CartBFCMUpsellMobile extends WDN.Component {
		constructor() {
			super();
			this.sectionToRender = "async-cart-bfcm-upsell";
			this.productSrc = this.getAttribute("data-product-url");
			this.paramChar = this.productSrc.indexOf("?") > -1 ? "&" : "?";
			this.endpoint =
				this.productSrc + this.paramChar + "section_id=" + this.sectionToRender;
			this.modal = document.querySelector(
				'wdn-modal[data-id="cart_bfcm_upsell"]'
			);
			this.outputTarget = this.modal.querySelector(
				"[data-cart-gift-bfcm-mobile]"
			);

			this.isSearchResultItem = false;
			this.mount();
		}

		loadContent(req_config) {
			WDN.Request.Get(req_config);
		}

		loadQuickshop() {
			this.loadContent({
				url: this.endpoint,
				onSuccess: function (res) {
					this.outputTarget.innerHTML = res;

					this.modal.open();

					if (!this.maintainStateOnAdd) return;

					var form = this.modal.querySelector("wdn-product-form");

					if (!form) return;
					if (typeof form.onAdd === "function") return;

					form.onAdd = function () {
						this.setAttribute("data-state", "success");
					}.bind(this);
				}.bind(this),
				onError: function (r) { },
			});
		}

		handleClick() {
			if (!this.quickshopLoaded) {
				this.loadQuickshop();
			}
		}

		addEventListeners() {
			this.addEventListener("click", this.handleClick.bind(this));
		}

		mount() {
			this.addEventListeners();
		}
	}

	customElements.define("cart-bfcm-upsell-mobile", CartBFCMUpsellMobile);
}

customElements.define("wdn-option", WDNOption);
if (!customElements.get("wdn-select")) {
	customElements.define("wdn-select", WDNSelect);
}
customElements.define("wdn-variant-select", WDNVariantSelect);
customElements.define("wdn-addon-select", WDNAddonSelect);
customElements.define("wdn-product-addon", WDNAddOn);
customElements.define("wdn-addon-steps", WDNAddonSteps);

class WDNQuickshopVariantSelect extends WDNVariantSelect {
	bodyOnClick(e) {
		if (this.hasAttribute("data-step-lock")) {
			const stepsEl = this.closest("wdn-quickshop-steps");
			if (stepsEl && stepsEl.contains(e.target)) return;
		}

		const parentQuickshop = this.closest("wdn-quickshop");
		if (parentQuickshop && !parentQuickshop.contains(e.target)) {
			this.active(false);
			this.unbindBody();
			return;
		}

		super.bodyOnClick(e);
	}
}
customElements.define("wdn-quickshop-variant-select", WDNQuickshopVariantSelect);

class WDNMobileQuickshopSteps extends HTMLElement {
	connectedCallback() {
		this.items = [...this.querySelectorAll("wdn-variant-select[data-option-index]")];
		this.navLabels = [...this.parentElement.querySelectorAll("[data-step-nav]")];
		this.stepTitles = [...this.parentElement.querySelectorAll("[data-step-title]")];

		if (this.items.length <= 1) return;

		this.activeIndex = 0;

		this.items.forEach((el, i) => {
			if (i !== 0) el.classList.add("hidden");
		});

		this._onOptionSelected = this.onOptionSelected.bind(this);
		document.body.addEventListener("option:selected", this._onOptionSelected);

		this.items.forEach((el) => {
			const backBtn = el.querySelector("[data-mobile-quickshop-back]");
			if (backBtn) backBtn.addEventListener("click", () => this.goBack());
		});
	}

	setNavLabel(index, state) {
		const label = this.navLabels[index];
		if (!label) return;
		label.removeAttribute("data-active");
		label.removeAttribute("data-completed");
		if (state === "active") label.setAttribute("data-active", "");
		else if (state === "completed") label.setAttribute("data-completed", "");
	}

	setActiveStepTitle(index) {
		this.stepTitles.forEach((el, i) => {
			el.classList.toggle("hidden", i !== index);
		});
	}

	onOptionSelected(e) {
		const stepEl = e.detail;
		if (!stepEl || !this.contains(stepEl)) return;

		const index = Number(stepEl.getAttribute("data-option-index"));
		if (index !== this.activeIndex) return;

		const next = this.items[index + 1];

		if (!next) {
			this.setAttribute("data-all-steps-complete", "");
			this.setNavLabel(index, "completed");
			return;
		}

		this.setNavLabel(index, "completed");
		this.setNavLabel(index + 1, "active");
		this.setActiveStepTitle(index + 1);

		this.items[index].classList.add("hidden");
		next.classList.remove("hidden");
		this.activeIndex++;
	}

	goBack() {
		if (this.activeIndex === 0) return;

		this.setNavLabel(this.activeIndex, "inactive");
		this.setNavLabel(this.activeIndex - 1, "active");
		this.setActiveStepTitle(this.activeIndex - 1);

		this.items[this.activeIndex].classList.add("hidden");
		this.activeIndex--;
		this.items[this.activeIndex].classList.remove("hidden");
		this.removeAttribute("data-all-steps-complete");
	}

	disconnectedCallback() {
		if (this._onOptionSelected) {
			document.body.removeEventListener("option:selected", this._onOptionSelected);
		}
	}
}
customElements.define("wdn-mobile-quickshop-steps", WDNMobileQuickshopSteps);

class WDNQuickshopSteps extends HTMLElement {
	connectedCallback() {
		this.items = [...this.querySelectorAll("wdn-quickshop-variant-select")];
		this.productForm = this.closest(".quickshop")?.querySelector("wdn-product-form");

		if (this.items.length < 1) return;

		this.activeIndex = 0;

		this.dataset.step = "1";

		this._onOptionSelected = this.onOptionSelected.bind(this);
		this._onVariantSelected = this.onVariantSelected.bind(this);
		document.body.addEventListener("option:selected", this._onOptionSelected);
		document.body.addEventListener("variant:selected", this._onVariantSelected);

		const clearBtn = this.closest(".quickshop")?.querySelector("[data-quickshop-clear]");
		if (clearBtn) {
			clearBtn.addEventListener("click", this.reset.bind(this));
		}
	}

	onOptionSelected(e) {
		const stepEl = e.detail;
		if (!stepEl || !this.contains(stepEl)) return;

		const index = Number(stepEl.getAttribute("data-option-index"));
		if (index !== this.activeIndex) return;

		const current = this.items[index];
		const next = this.items[index + 1];

		if (!next) {
			this.removeAttribute("data-step");
			this.setAttribute("data-all-steps-complete", "");
			return;
		}

		current.removeAttribute("data-step-lock");
		next.setAttribute("data-step-lock", "");

		this.activeIndex++;
		this.dataset.step = this.activeIndex + 1;

		next.expandContainer();
	}

	onVariantSelected(e) {
		if (!this.hasAttribute("data-all-steps-complete")) return;
		const selectEl = e.detail;
		if (!this.contains(selectEl)) return;
		const variant = selectEl.selectedVariant;
		if (!variant) return;
		const choiceEl = this.closest(".quickshop")?.querySelector("[data-quickshop-choice]");
		if (!choiceEl) return;
		choiceEl.innerHTML = variant.title !== "Default Title" ? variant.title : "";
	}

	reset() {
		this.activeIndex = 0;
		this.removeAttribute("data-all-steps-complete");
		this.dataset.step = "1";

		this.items.forEach(item => {
			item.clearActiveOption();
			item.selected_option = null;
			item.selectedVariant = false;
			item.setTriggerState("blank");
			item.shrinkContainer();
			item.removeAttribute("data-step-lock");
			item.titleContainers.forEach(el => (el.innerHTML = ""));
		});

		const choiceEl = this.closest(".quickshop")?.querySelector("[data-quickshop-choice]");
		if (choiceEl) choiceEl.innerHTML = "";
	}

	disconnectedCallback() {
		if (this._onOptionSelected) {
			document.body.removeEventListener("option:selected", this._onOptionSelected);
		}
		if (this._onVariantSelected) {
			document.body.removeEventListener("variant:selected", this._onVariantSelected);
		}
	}
}

customElements.define("wdn-quickshop-steps", WDNQuickshopSteps);
customElements.define("wdn-product-swiper", WDNProductSwiper);
customElements.define("wdn-quickshop", WDNQuickshop);
customElements.define("wdn-quickshop-trigger", WDNQuickshopTrigger);
customElements.define("wdn-product-card", WDNProductCard);

if (typeof WDN.Checkout === "undefined") {
	WDN.Checkout = (function () {
		var init, onFormSubmit;
		var checkout_form = document.querySelector("[data-checkout-form]");

		onFormSubmit = function (e) {
			document.body.dispatchEvent(
				new CustomEvent("checkout", { detail: this })
			);
		};

		init = function () {
			if (!checkout_form) return;
			checkout_form.addEventListener("submit", onFormSubmit);
		};

		init();
		return {};
	})();
}

class WDNArticleOpen extends WDNModalOpen {
	constructor() {
		super();
		this.article_handle = this.getAttribute("data-article-handle");
		this.modal_content = this.element.querySelector("[data-article-modal]");
		this.template = "look-blank";
		this.element.onClose = this.onModalClose.bind(this);
		this.element.onOpen = this.onModalOpen.bind(this);
	}

	onModalClose() {
		document.body.classList.remove("article-overlay-open");
	}

	onModalOpen() {
		document.body.classList.add("article-overlay-open");
	}

	onFetchError() {
		this.isAwaitingResponse = false;
	}

	onFetchSuccess(res) {
		this.isAwaitingResponse = false;
		this.modal_content.setAttribute("data-article-modal", this.article_handle);
		this.modal_content.innerHTML = res;
		this.element.open();
	}

	fetchLayout() {
		if (this.isAwaitingResponse) return;
		WDN.Request.Get({
			url:
				WDN.Routes.root_url +
				"blogs/" +
				this.article_handle +
				"?view=" +
				this.template,
			onSuccess: this.onFetchSuccess.bind(this),
			onError: this.onFetchError.bind(this),
		});
		this.isAwaitingResponse = true;
	}

	handleClick() {
		if (
			this.modal_content.getAttribute("data-article-modal") ===
			this.article_handle
		) {
			this.element[this.action]();
		} else {
			this.fetchLayout();
		}
	}
}

customElements.define("wdn-article-open", WDNArticleOpen);

class WDNScrollX extends WDN.Component {
	constructor() {
		super();
		this.config = {
			transform_offset: 40,
			transform_interval: 20,
		};
		this.target_selector = this.getAttribute("data-target");
		this.target = document.querySelector(this.target_selector);
		this.direction = this.getAttribute("data-direction") || "right";
		this.bindElement(this, "click", this.onClick.bind(this));
	}

	transformRight() {
		return;
	}

	transformLeft() {
		return;
	}

	setIntervalDirection(direction) {
		var callback =
			direction === "right"
				? this.transformRight.bind(this)
				: this.transformLeft.bind(this);
		callback();
		return;
	}

	transform(direction) {
		direction = direction || this.direction;
		this.setIntervalDirection(direction);
		this.callback("onTransform");
	}

	onClick() {
		this.transform();
	}
}

customElements.define("wdn-scroll-x", WDNScrollX);

class WDNAddonCheckbox extends WDNCheckbox {
	constructor() {
		super();
		this.addon_modal = this.getAddonModalBy_id(this.id);
	}

	getAddonModalBy_id(id) {
		return (
			document.querySelector("wdn-addon-modal[data-id='" + id + "']") || false
		);
	}

	open_addon_modal() {
		if (!this.addon_modal) return;
		this.addon_modal.onClick();
	}

	clearError() {
		const errorBanner = this.closest(".product-addon")?.querySelector("[data-addon-update-error]");
		if (!errorBanner) return;
	}

	showError(str) {
		if (!str?.trim()) return;
		const errorBanner = this.closest(".product-addon")?.querySelector("[data-addon-update-error]");
		if (!errorBanner) return;
		errorBanner.innerText = str;
	}

	setLoading(isLoading) {
		this.setAttribute("data-loading", isLoading ? "true" : "false");
	}


	async addToCart(id) {
		let res, data
		try {
			res = await fetch(window.Shopify.routes.root + "cart/add.js", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
			});

			data = await res.json();
		} catch (error) {
			console.error(error)
			throw new Error("Error")
		}

		if (!res.ok || data?.status >= 400) {
			throw new Error(data.description || data.message || "An error occurred.")
		}

		this.fireEvent({
			name: "product:added",
			detail: res,
		});

		this.fireEvent({
			name: "cart:updated",
			detail: res,
		});

		document
			.querySelector("wdn-cart")
			?.reloadCart(true, true);

		const successMessage = this.closest(".product-addon")?.querySelector(".product-addon__success")
		if (successMessage) {
			successMessage.classList.remove("product-addon__success--hidden")
			setTimeout(() => {
				successMessage.classList.add("product-addon__success--hidden")
			}, 2000)
		}
	}

	async removeFromCart(id) {
		// Note: removes all quantity for the specific variant
		let res, data
		try {
			res = await fetch(window.Shopify.routes.root + "cart/change.js", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ id: String(id), quantity: 0 }),
			});

			data = await res.json();
		} catch (error) {
			console.error(error)
			throw new Error("Error")
		}

		if (!res.ok || data?.status >= 400) {
			throw new Error(data.description || data.message || "An error occurred.")
		}

		document
			.querySelector("wdn-cart")
			?.reloadCart(null, true);
	}

	async handleChange(variantId) {
		this.clearError();
		this.setLoading(true);

		let hasError = false
		try {
			this.isChecked ? await this.removeFromCart(variantId) : await this.addToCart(variantId);
		} catch (error) {
			this.showError(error?.message || "Error")
			hasError = true
		}

		this.setLoading(false);

		if (!hasError) {
			this.setState(!this.isChecked);
			this.callback("onChange", this);
		}
	}

	async onClick() {
		if (this.isDisabled) return;
		if (this.dataset.hasOptions === "false" || this.value) {
			await this.handleChange(this.value)
		} else {
			this.clearError();
			this.open_addon_modal();
		}
	}
}

customElements.define("wdn-addon-checkbox", WDNAddonCheckbox);

class WDNAddonModal extends WDN.Component {
	constructor() {
		super();
		this.id = this.getAttribute("data-id");
		this.product_id = this.getAttribute("data-product-id");
		this.element_id = "product_addon_" + this.product_id;
		this.checkbox = document.querySelector(
			"wdn-addon-checkbox[data-id='" + this.element_id + "']"
		);
		this.modal = document.querySelector("wdn-modal[data-id='product_addon']");
		this.layout_container = this.modal.querySelector("[data-addon-layout]");
		this.init();
	}

	createParentContainer() {
		var newDiv = document.createElement("div");
		newDiv.setAttribute("data-addon-item", this.product_id);
		return newDiv;
	}

	assignNewNodes() {
		this.modal_button = this.itemParent.querySelector("[data-addon-submit]");
		this.variant_select = document.querySelector(
			"wdn-variant-select[data-id='" + this.element_id + "']"
		);
		this.variant_select.onVariantChange = this.onVariantChange.bind(this);
	}

	validateControls() {
		var selectedVariant = this.variant_select.selectedVariant;
		var state = true;
		if (selectedVariant && selectedVariant.available) {
			state = !selectedVariant.available;
			this.checkbox.value = selectedVariant.id;
		}
		if (state) {
			this.checkbox.value = "";
		}
		this.modal_button.disabled = state;
	}

	set_modal_button_state(newState) {
		if (!this.modal_button || !newState) return;
		this.modal_button.setAttribute("data-state", newState);
	}

	onVariantChange() {
		this.validateControls();
		this.set_modal_button_state(this.variant_select.getState());
	}

	outputResponse(res) {
		this.layout_container.insertAdjacentElement(
			"beforeend",
			this.createParentContainer()
		);
		this.itemParent = this.layout_container.querySelector(
			"[data-addon-item='" + this.product_id + "']"
		);
		this.itemParent.innerHTML = res;
	}

	onFetch(res) {
		this.outputResponse(res);
		this.assignNewNodes();
		this.setInitialState();
		this.modal.open();
		this.bindElement(
			this.modal_button,
			"click",
			this.onModalButtonClick.bind(this)
		);
		this.isFetching = false;
	}

	setInitialState() {
		if (!this.variant_select) return;
		this.validateControls();
	}

	onModalButtonClick() {
		var selectedVariant = this.variant_select.selectedVariant;
		if (!selectedVariant && !selectedVariant.available) return;
		// this.checkbox.setState(true);
		this.modal_button.disabled = false;
		this.modal.close();
		this.checkbox.handleChange(this.checkbox.value)
	}

	onFetchError() {
		this.isFetching = false;
	}
	fetchLayout() {
		this.isFetching = true;
		this.Request.Get({
			url:
				this.Routes.search_url +
				"?view=addon&type=product&q=id:" +
				this.product_id,
			onSuccess: this.onFetch.bind(this),
			onError: this.onFetchError.bind(this),
		});
	}

	hideAllItems() {
		var parents = this.layout_container.querySelectorAll("[data-addon-item]");
		parents.forEach(function (parent) {
			parent.classList.add("hidden");
		});
	}

	onClick() {
		if (this.isFetching) return;
		this.hideAllItems();
		if (this.itemParent) {
			this.setInitialState();
			this.itemParent.classList.remove("hidden");
			this.modal.open();
		} else {
			this.fetchLayout();
		}
	}

	bind() {
		this.bindElement(this, "click", this.onClick.bind(this));
	}

	validateCheckbox() {
		if (!this.checkbox.value || this.checkbox.value == "") {
			this.checkbox.disable();
		}
	}

	init() {
		this.bind();
	}
}
customElements.define("wdn-addon-modal", WDNAddonModal);

/* OUR HISTORY */
/* OUR HISTORY */
/* OUR HISTORY */

if (typeof WDN.HistoryYears === "undefined") {
	WDN.HistoryYears = (function () {
		var init, bind, outputYears, generateTemplate, generateOutputContent;
		var windowOnScroll,
			selectNewNodes,
			setActive,
			clearActiveYear,
			windowOnResize;
		var setMode, storeSectionsPosition, getSectionYear, getSectionMode;
		var config = WDN.HistoryConfig; // depends on

		var Debounce = WDN.Debounce; // depends on

		var header_height = parseInt(
			document.documentElement.style.getPropertyValue("--header-height")
		);

		var nodes = {
			section_containers: document.querySelectorAll("[data-target-year]"),
			output_container: document.querySelector("[data-history-years]"),
			output_wrapper: document.querySelector("[data-history-wrapper]"),
			sticky_begin_section: document.querySelector("[data-sticky-begin]"),
			sticky_end_section: document.querySelector("[data-sticky-end]"),
			indicators: [], // will be selected dynamically
		};

		var storage = [];

		var current = {
			year: false,
			mode: false,
			scroll_position: false,
		};

		clearActiveYear = function () {
			var activeYears = document.querySelectorAll(
				"[data-history-year][data-active]"
			);
			activeYears.forEach(function (year) {
				year.removeAttribute("data-active");
			});
		};

		setMode = function (newMode) {
			if (current.mode == newMode) return;
			nodes.output_container.setAttribute("data-mode", newMode);
			current.mode = newMode;
			document.body.setAttribute("data-mode", newMode);
		};

		setActive = function (section) {
			var reqYear = getSectionYear(section.el);
			var mode = getSectionMode(section.el);

			setMode(mode);

			if (current.year == reqYear) return;
			clearActiveYear();
			nodes.indicators.forEach(function (indicator) {
				var indicatorAttribute = indicator.getAttribute("data-history-year");
				if (indicatorAttribute == reqYear) {
					indicator.setAttribute("data-active", "");
					current.year = reqYear;
				}
			});
		};

		selectNewNodes = function () {
			nodes.indicators = document.querySelectorAll("[data-history-year]");
		};

		generateTemplate = function (year, index) {
			var attr = "";
			if (index == 0) {
				attr = "data-active";
				current.year = year;
			}
			var content =
				"<wdn-scroll-link data-target='year_" +
				year +
				"'>" +
				year +
				"</wdn-scroll-link>";
			var wrapper =
				'<div class="history-year" data-history-year="' +
				year +
				'" ' +
				attr +
				">" +
				content +
				"</div>";

			return wrapper;
		};

		generateOutputContent = function () {
			var data = [];
			config.data.forEach(function (year, i) {
				data.push(generateTemplate(year, i));
			});
			return data;
		};

		outputYears = function () {
			var content = generateOutputContent();
			nodes.output_container.innerHTML = "";
			nodes.output_container.insertAdjacentHTML("beforeend", content.join(""));
		};

		getSectionYear = function (section) {
			return section.getAttribute("data-target-year");
		};

		var getActiveSection = function () {
			return current.section;
		};

		getSectionMode = function (section) {
			var mode = section.getAttribute("data-year-mode");
			if (!mode || mode == "") {
				mode = "light";
			}
			return mode;
		};

		var storeScrollPosition = function (newPosition) {
			current.scroll_position = newPosition;
		};

		var getScrollPosition = function () {
			return (
				window.pageYOffset || document.documentElement.scrollTop + header_height
			);
		};

		var getScrollDirection = function () {
			var direction = "down";
			if (current.scroll_position > getScrollPosition()) {
				direction = "up";
			}
			return direction;
		};

		var getTopPositionOfElement = function (element) {
			var rect = element.getBoundingClientRect();
			return rect.top + window.pageYOffset; //- header_height;
		};

		var validateStorage = function () {
			var scroll_top_pos = getScrollPosition() + header_height;
			if (scroll_top_pos < 100) {
				setMode("dark");
			} else if (
				scroll_top_pos <
				getTopPositionOfElement(nodes.sticky_begin_section) - header_height
			) {
				current.section = false;
				setMode("light");
			} else if (
				scroll_top_pos >
				getTopPositionOfElement(nodes.sticky_end_section) +
				nodes.sticky_end_section.offsetHeight -
				header_height
			) {
				current.section = false;
				setMode("light");
			} else {
				for (var i = 0; i < storage.length; i++) {
					var section = storage[i];

					if (
						scroll_top_pos >= section.top &&
						scroll_top_pos <= section.max_offset
					) {
						if (current.section == section) return;
						current.section = section;
						setActive(section);
						break;
					}
				}
			}
			storeScrollPosition(scroll_top_pos);

			return;

			for (var i = 0; i < storage.length; i++) {
				var section = storage[i];
				if (
					scroll_top_pos >= section.top &&
					scroll_top_pos <= section.max_offset
				) {
					if (current.section == section) return;
					current.section = section;
					setActive(section);
					break;
				}
			}

			if (
				scroll_top_pos < getTopPositionOfElement(nodes.sticky_begin_section)
			) {
				setMode("light");
			}

			storeScrollPosition(scroll_top_pos);
		};

		storeSectionsPosition = function () {
			storage = [];
			nodes.section_containers.forEach(function (container) {
				var calc_offset = container.offsetHeight / 2; // random offset, to apply effect earlier
				var el_top_pos = getTopPositionOfElement(container) - header_height;
				var el_max_top = el_top_pos + container.offsetHeight;
				var sticky_begins = container.getAttribute("data-sticky-begin") == "";
				var sticky_ends = container.getAttribute("data-sticky-end") == "";

				storage.push({
					top: el_top_pos,
					el: container,
					el_height: container.offsetHeight,
					max_offset: el_max_top - calc_offset,
					sticky_begins: sticky_begins,
					sticky_ends: sticky_ends,
				});
			});
		};

		var set_output_top = function (newTop) {
			nodes.output_wrapper.style.top = newTop + "px";
		};

		var set_output_height = function (newHeight) {
			nodes.output_wrapper.style.height = newHeight + "px";
		};

		var position_output_wrapper = function () {
			var begin_dist_top =
				getTopPositionOfElement(nodes.sticky_begin_section) + header_height;
			var end_dist_top =
				getTopPositionOfElement(nodes.sticky_end_section) + header_height;
			var output_height = nodes.output_container.offsetHeight;
			var top_calc =
				begin_dist_top +
				nodes.sticky_begin_section.offsetHeight / 2 -
				output_height / 2;
			var height_calc =
				end_dist_top -
				top_calc +
				nodes.sticky_end_section.offsetHeight / 2 +
				output_height / 2;

			set_output_top(top_calc);
			set_output_height(height_calc);
		};

		windowOnScroll = function () {
			validateStorage();
		};

		windowOnResize = function () {
			storeSectionsPosition();
			setTimeout(function () {
				position_output_wrapper();
			}, 160);
		};

		var onHeaderHeightUpdate = function () {
			header_height = parseInt(
				document.documentElement.style.getPropertyValue("--header-height")
			);
		};

		bind = function () {
			var debouncedScroll = Debounce(windowOnScroll, 10);
			document.body.addEventListener(
				"header_height:updated",
				onHeaderHeightUpdate
			);
			window.addEventListener("scroll", debouncedScroll);
			window.addEventListener("window:resize", windowOnResize);
		};

		init = function () {
			if (!nodes.output_container) return;

			outputYears();
			storeSectionsPosition();
			position_output_wrapper();
			selectNewNodes();
			bind();
		};

		if (nodes.section_containers.length > 0) {
			init();
		}

		return { clearActiveYear, setActive, getActiveSection };
	})();
}

/* Page Search */

class WDNSearch extends WDN.Component {
	constructor() {
		super();

		this.dependencies = {
			Routes: WDN.Routes,
			Request: WDN.Request,
		};

		this.config = {
			template: "main",
			type: "*",
			debounce: 380,
		};

		this.nodes = {
			input: this.querySelector("input"),
			submit: this.querySelector("[data-submit]"),
			container: this.querySelector("[data-container]"),
			results: this.querySelector("[data-search-results]"),
		};
		this.data = {
			input_value: this.nodes.input.value,
		};

		this.init();
	}

	onFetchError() {
		this.isFetching = false;
	}

	onFetchSuccess(res) {
		this.renderContent(res);
		this.expandResults();
		this.bindBody();
		this.isFetching = false;
	}

	generateEndpoint() {
		var searchEndpoint = this.dependencies.Routes.search_url;
		var query = this.data.input_value;
		var url =
			searchEndpoint +
			"?q=" +
			query +
			"&type=" +
			this.config.type +
			"&view=" +
			this.config.template;
		return url;
	}

	renderContent(content) {
		this.nodes.results.innerHTML = content;
	}

	sendRequest() {
		if (this.isFetching) return;
		this.data.input_value = this.nodes.input.value.trim();
		this.collapseResults();
		if (this.data.input_value == "") return;
		this.dependencies.Request.Get({
			url: this.generateEndpoint(),
			onSuccess: this.onFetchSuccess.bind(this),
			onError: this.onFetchError.bind(this),
		});
		this.isFetching = true;
	}

	inputOnKeyUp() {
		clearTimeout(this.timer);
		this.timer = setTimeout(this.sendRequest.bind(this), this.config.debounce);
	}

	inputOnFocus() {
		if (this.data.input_value == "") return;
		this.expandResults();
		this.bindBody();
	}

	expandResults() {
		var contentHeight = this.nodes.results.offsetHeight;
		this.setContainerHeight(contentHeight);
		this.setState("active");
	}

	setContainerHeight(newHeight) {
		this.nodes.container.style.height = newHeight + "px";
	}

	collapseResults() {
		this.setContainerHeight(0);
		this.setState("default");
	}

	bodyOnClick(e) {
		if (!this.contains(e.target)) {
			this.collapseResults();
			this.unbindBody();
		}
	}

	submitOnClick(e) {
		if (e) e.preventDefault();
		this.sendRequest();
	}

	setState(newState) {
		this.setAttribute("data-state", newState);
	}

	getState() {
		return this.getAttribute("data-state");
	}

	bindBody() {
		if (this.bodyBound) return;
		this.bodyBound = true;
		this.bindElement(document.body, "click", this.bodyOnClickBound);
	}

	unbindBody() {
		this.bodyBound = false;
		this.unbindElement(document.body, "click", this.bodyOnClickBound);
	}

	bind() {
		this.bodyOnClickBound = this.bodyOnClick.bind(this);
		this.bindElement(this.nodes.input, "keyup", this.inputOnKeyUp.bind(this));
		this.bindElement(this.nodes.input, "focus", this.inputOnFocus.bind(this));
		this.bindElement(this.nodes.submit, "click", this.submitOnClick.bind(this));
	}

	init() {
		this.bind();
	}
}

class WDNPageSearch extends WDNSearch {
	constructor() {
		super();
		this.config = {
			template: "faq",
			type: "page",
			debounce: 380,
		};
	}
}

class WDNArticleSearch extends WDNSearch {
	constructor() {
		super();
		this.config = {
			template: "blog",
			type: "article",
			debounce: 380,
		};
	}
}

customElements.define("wdn-search", WDNSearch);
customElements.define("wdn-page-search", WDNPageSearch);
customElements.define("wdn-article-search", WDNArticleSearch);

/* Module that toggles layout after element has been scrolled past */
if (typeof WDN.OnReach === "undefined") {
	WDN.OnReach = (function () {
		var init, bind, windowOnScroll, windowOnResize, storeData;
		var applyEffect, removeEffect, getHeaderHeight, getStickyHeaderHeight;

		var Header = WDN.Header; // depends on

		getHeaderHeight = function () {
			return parseInt(
				document.documentElement.style.getPropertyValue("--header-height")
			);
		};

		getStickyHeaderHeight = function () {
			return parseInt(
				document.documentElement.style.getPropertyValue(
					"--sticky-header-height"
				)
			);
		};

		var config = {
			debounce_offset: 15,
			header_height: getStickyHeaderHeight(),
		};

		var nodes = {
			elements: document.querySelectorAll("[data-on-reach]"),
		};
		var fireEvent = function (data) {
			var target = data.target || document.body;
			target.dispatchEvent(new CustomEvent(data.name, { detail: data.detail }));
		};

		// will contain element with their top position
		var data = [];

		applyEffect = function (storage) {
			if (storage.hasEffect) return;
			storage.hasEffect = true;
			if (storage.maintain_height) {
				storage.el.parentNode.style.height = storage.el_height + "px";
			}

			if (storage.id && storage.id !== "") {
				fireEvent({
					name: "reached:" + storage.id,
				});
			}
			storage.el.setAttribute("data-layout", storage.attr_value);

			if (storage.affects_header) {
				Header.updateVariable(getHeaderHeight() + storage.el.offsetHeight);
				config.header_height = getHeaderHeight();
			}
		};

		removeEffect = function (storage) {
			if (!storage.hasEffect) return;
			storage.hasEffect = false;
			storage.el.removeAttribute("data-layout");
			if (storage.maintain_height) {
				//    storage.el.parentNode.style.height = "auto";
			}
			if (storage.affects_header) {
				Header.resetHeight();
				config.header_height = getHeaderHeight();
			}

			if (storage.id && storage.id !== "") {
				fireEvent({
					name: "left:" + storage.id,
				});
			}
		};

		storeData = function () {
			data = [];
			nodes.elements.forEach(function (element) {
				var el_rect = element.getBoundingClientRect();
				var el_attr_value = element.getAttribute("data-on-reach");
				var offset = 30;
				data.push({
					hasEffect: false,
					id: element.getAttribute("data-id"),
					el: element,
					el_height: element.offsetHeight,
					max_offset:
						el_rect.top + window.pageYOffset + element.offsetHeight - offset,
					hasEffect: element.getAttribute("data-layout") == el_attr_value,
					attr_value: el_attr_value,
					maintain_height: element.getAttribute("data-maintain-height") == "",
					affects_header: element.getAttribute("data-affects-header") == "",
				});
			});
		};

		windowOnResize = function () {
			storeData();
		};

		windowOnScroll = function () {
			data.forEach(function (storage) {
				var scrollPosition = window.scrollY + config.header_height;
				if (scrollPosition > storage.max_offset) {
					applyEffect(storage);
				} else {
					removeEffect(storage);
				}
			});
		};
		var onHeaderHeightUpdate = function () {
			return;
			config.header_height = getHeaderHeight();
		};

		bind = function () {
			var windowOnScrollDebounced = WDN.Debounce(
				windowOnScroll,
				config.debounce_offset
			);
			window.addEventListener("scroll", windowOnScrollDebounced);
			window.addEventListener("window:resize", windowOnResize);
			document.body.addEventListener(
				"header_height:updated",
				onHeaderHeightUpdate
			);
		};
		init = function () {
			if (nodes.elements.length == 0) return;
			storeData();
			bind();
		};

		init();
		return {};
	})();
}

class WDNMovingParticles extends WDN.Component {
	constructor() {
		super();
		this.id = this.getAttribute("data-id");
		this.config = {
			transition_offset: 18,
			preserve_height: false,
			watch_scroll_perc: !!this.getAttribute("data-watch-scroll"), //apply scrolled-past class to body
			style_perc: 20,
			particle_scroll_anim: false,
			debounce_move: 0,
			header_height:
				parseInt(
					document.documentElement.style.getPropertyValue("--header-height")
				) || 0,
		};
		this.nodes = {
			particles: this.querySelectorAll("[data-particle]"),
		};
		this.data = {};
		this.init();
	}

	isInViewport() {
		var start = this.data.element_top_start;
		return window.scrollY > start && window.scrollY < this.data.element_top_end;
	}

	storeCurrentScrollPos() {
		this.data.scroll_position = window.scrollY;
	}

	getScrollDirection() {
		var dir = "down";
		if (window.scrollY < this.data.scroll_position) {
			dir = "up";
		}
		return dir;
	}

	translateParticlesY(Ypos) {
		this.nodes.particles.forEach(function (particle) {
			particle.style = "transform:translateY(" + Ypos + "px)";
		});
	}

	translateParticles(Xpos, Ypos) {
		this.nodes.particles.forEach(function (particle) {
			let magnitude = particle.dataset.particle * 0.2;
			let newXPos = Xpos * magnitude;
			let newYPos = Ypos * magnitude;
			particle.style =
				"transform:translate(" + newXPos + "px ," + newYPos + "px)";
		});
	}

	onTopReach() {
		this.translateParticlesY(0);
	}

	onScrollUp() {
		this.translateParticlesY(0);
	}

	onScrollDown() {
		this.translateParticlesY(-this.config.transition_offset);
	}

	getScrollPercentage() {
		var scroll_position = window.scrollY;
		var max_offset = this.data.element_top_end;
		return (scroll_position * 120) / max_offset;
	}

	applyScrollClass(state) {
		if (state) {
			document.body.classList.add("scrolled-past");
		} else {
			document.body.classList.remove("scrolled-past");
		}
	}

	windowOnScroll() {
		if (!this.isInViewport) {
			applyScrollClass(true);
			return;
		}
		if (window.scrollY == 0) {
			//this.onTopReach();
			this.storeCurrentScrollPos();
			return;
		}

		this.handleParticleScrollAnimation();
		if (!this.config.watch_scroll_perc) return;
		this.applyScrollClass(this.getScrollPercentage() > this.config.style_perc);
	}

	handleParticleScrollAnimation() {
		if (!this.config.particle_scroll_anim) return;
		if (this.getScrollDirection() == "up") {
			this.onScrollUp();
		} else {
			this.onScrollDown();
		}
		this.storeCurrentScrollPos();
	}

	windowOnResize() {
		this.generate_data();
		if (!this.config.preserve_height) return;
		this.setElementHeight("auto");
		this.adjustElement();
	}

	generate_data() {
		var el_rect = this.getBoundingClientRect();
		var header_height = this.config.header_height;
		var el_top_pos = el_rect.top + window.pageYOffset - header_height;
		var el_top_end = el_top_pos + this.offsetHeight;
		this.data = {
			element_rect: el_rect,
			element_top_start: el_top_pos,
			element_top_end: el_top_end,
			header_height: header_height,
		};
	}
	setElementHeight(newHeight) {
		this.style.height = newHeight;
	}

	adjustElement() {
		if (!this.config.preserve_height) return;
		this.setElementHeight(this.offsetHeight + "px");
	}

	onMouseMove(e) {
		//if (!this.isInViewport()) return;
		var posX = (e.clientX * -1) / (this.config.transition_offset * 2);
		var posY = (e.clientY * -1) / this.config.transition_offset;
		this.translateParticles(posX.toFixed(2), posY.toFixed(2));
	}

	onHeaderHeightUpdate() {
		this.config.header_height =
			parseInt(
				document.documentElement.style.getPropertyValue("--header-height")
			) || 0;
	}

	bind() {
		var onMouseMove = this.onMouseMove.bind(this);
		this.bindElement(this, "mousemove", onMouseMove);
		this.bindElement(
			document.body,
			"header_height:updated",
			this.onHeaderHeightUpdate.bind(this)
		);
		this.bindElement(window, "scroll", this.windowOnScroll.bind(this));
		this.bindElement(window, "resize", this.windowOnResize.bind(this));
	}

	init() {
		if (this.nodes.particles.length == 0) return;
		this.adjustElement();
		this.generate_data();
		this.bind();
		if (!this.config.watch_scroll_perc) return;
		this.applyScrollClass(this.isInViewport());
	}
}

customElements.define("wdn-moving-particles", WDNMovingParticles);

(function () {
	var init, generate_data, get_output_data, output_results;
	var format_date_number, format_date;

	// config
	var config = {
		min_days_from_today: 3,
		max_days_from_min_date: 180,
		ms_in_day: 86400000,
	};

	var nodes = {
		output_containers: document.querySelectorAll("[data-shipping-dispatch]"),
	};

	var dependencies = {
		translations: Translations, // coming from theme.liquid
	};

	// will be populated on init
	var data = {
		today: false,
		min_date: false,
		max_date: false,
	};

	format_date_number = function (number) {
		var string_number = "" + number;
		if (string_number.length == 1) {
			number = 0 + string_number;
		}

		return number;
	};

	format_date = function (day, month) {
		var translations = dependencies.translations.date_formatting;
		return (
			format_date_number(day) + translations.dash + format_date_number(month)
		);
	};

	get_output_data = function () {
		var translations = dependencies.translations.date_formatting;
		var min_date_formatted = format_date(
			data.min_date.getDate(),
			data.min_date.getMonth() + 1
		);
		var max_date_formatted = format_date(
			data.max_date.getDate(),
			data.max_date.getMonth() + 1
		);
		return " " + max_date_formatted + translations.to + min_date_formatted;
	};

	output_results = function () {
		var output_data = get_output_data();
		nodes.output_containers.forEach(function (container) {
			container.innerHTML = output_data;
		});
	};

	generate_data = function () {
		var today = new Date();
		var min_date_from_today = new Date(
			today - config.min_days_from_today * config.ms_in_day
		);
		var max_date_from_min_date = new Date(
			min_date_from_today - config.max_days_from_min_date * config.ms_in_day
		);

		data = {
			today: today,
			min_date: min_date_from_today,
			max_date: max_date_from_min_date,
		};
	};

	init = function () {
		if (nodes.output_containers.length == 0) return;
		generate_data(); // generates dates based on config
		output_results(); // outputs date range(s)
	};

	init();
})();

class WDNVideo extends HTMLElement {
	constructor() {
		super();
		this.playing;
		this.autoplay;
		this.muted;
		this.currentState;
		this.hasControls; // used to add control to html tag
		this.init();
		this.playPromise;
	}

	attachNodes() {
		this.videoplayer = this.querySelector("video");
		this.playTriggerList = this.querySelectorAll("[data-video-play]");
	}

	readDefaults() {
		this.autoplay = !!this.videoplayer.hasAttribute("autoplay");
		this.muted = !!this.videoplayer.hasAttribute("muted");
		this.currentState = this.getAttribute("data-videoplayer");
		this.hasControls = this.hasAttribute("data-controls");

		if (this.autoplay) {
			this.currentState = "playing";
			this.setAttribute("data-videoplayer", "playing");
		}
	}

	onVideoEnd() {
		this.videoplayer.load();
		this.currentState = "default";
		this.setAttribute("data-videoplayer", "default");
	}

	updateState() {
		switch (this.currentState) {
			case "default": {
				this.currentState = "playing";
				this.setAttribute("data-videoplayer", "playing");
				this.playVideo();
				break;
			}
			case "playing": {
				this.currentState = "default";
				this.setAttribute("data-videoplayer", "default");
				this.pauseVideo();
				break;
			}
		}
	}

	playVideo() {
		if (this.hasControls) {
			this.videoplayer.controls = true;
		}

		this.videoplayer.play().then;
	}

	pauseVideo() {
		if (this.hasControls) {
			this.videoplayer.controls = false;
		}
		this.videoplayer.pause();
	}

	onPlayClick() {
		this.updateState();
	}

	registerListeners() {
		this.playTriggerList.forEach((elem) => {
			elem.addEventListener("click", this.onPlayClick.bind(this));
		});
	}

	init() {
		this.attachNodes();
		this.readDefaults();
		this.registerListeners();
	}
}

customElements.define("wdn-video", WDNVideo);

(function () {
	// auto track product visits, based on attribute on page
	var productHistory = new ViewedProducts();
	var target = document.querySelector("[data-product-track]");

	if (target) {
		productHistory.track(target.getAttribute("data-product-track"));
	}

	// setup autorender on recently viewed page
	if (typeof WDN.RenderViewedProducts != "undefined") {
		var pageRecentlyViewed = new WDN.RenderViewedProducts(
			"[data-recently-viewed-products]",
			"[data-recently-viewed-products-list]",
			productHistory
		);

		pageRecentlyViewed.start();
	}
})();

class WDNSCartShippingProgress extends HTMLElement {
	constructor() {
		super();

		this.shippingProgress;
		this.mount();
	}

	attachNodes() {
		this.progressBar = this.querySelector("[data-freeshipping-progress]");
		this.untilThresholdElem = this.querySelector(
			"[data-amount-until-freeshipping]"
		);
	}

	readIntFromElem(attribute_name, elem = this) {
		if (!attribute_name) {
			return;
		}

		return parseInt(elem.getAttribute(attribute_name));
	}

	readConfig() {
		this.cartTotal = this.readIntFromElem("data-cart-total");
		this.shippingPrice = this.readIntFromElem("data-shipping-price");
		this.shippingThreshold = this.readIntFromElem("data-shipping-threshold");
	}

	updateCSSVar() {
		document.documentElement.style.setProperty(
			"--shipping-progressbar",
			this.shippingProgress + "%"
		);
	}

	renderAmount() {
		this.untilThresholdElem.innerHTML = WDN.Money.Format(
			this.amountUntilFreeShipping
		);
	}

	setState() {
		if (this.shippingProgress >= 100) {
			this.setAttribute("data-goal-reached", "true");
		} else {
			this.setAttribute("data-goal-reached", "false");
		}
	}

	calculateProgress() {
		if (this.cartTotal === 0) {
			this.amountUntilFreeShipping = this.shippingThreshold;
			this.shippingProgress = 0;
			return;
		}

		if (this.cartTotal >= this.shippingThreshold) {
			this.amountUntilFreeShipping = 0;
			this.shippingProgress = 100;
			return;
		}

		this.amountUntilFreeShipping = this.shippingThreshold - this.cartTotal;
		this.shippingProgress = (this.cartTotal / this.shippingThreshold) * 100;
	}

	updatePercentage(percentage) {
		if (percentage > 100) {
			percentage = 100;
		}

		if (percentage < 0) {
			percentage = 0;
		}

		this.shippingProgress = percentage;
		this.renderAmount();
		this.updateCSSVar();
	}

	mount() {
		this.attachNodes();
		this.readConfig();
		this.calculateProgress();
		this.renderAmount();
		this.setState();

		setTimeout(() => {
			this.updateCSSVar();
		}, 500);
	}
}

customElements.define("wdn-cart-shipping-progress", WDNSCartShippingProgress);

var wdnhippingProgress = document.querySelector("wdn-cart-shipping-progress");

if (typeof WDN === "undefined") {
	var WDN = {};
}

WDN.Countdown = (function () {
	var lang_source = Translations.countdown;

	var countdownContainers = document.querySelectorAll(
		"[data-shipping-countdown]"
	);
	var countdownOutputs = document.querySelectorAll(
		"[data-shipping-countdown-output]"
	);

	var Labels_day = {
		monday: lang_source.day_of_week_name.monday,
		tuesday: lang_source.day_of_week_name.tuesday,
		wednesday: lang_source.day_of_week_name.wednesday,
		thursday: lang_source.day_of_week_name.thursday,
		friday: lang_source.day_of_week_name.friday,
		saturday: lang_source.day_of_week_name.saturday,
		sunday: lang_source.day_of_week_name.sunday,
	};

	function parseMillisecondsIntoReadableTime(milliseconds) {
		//Get hours from milliseconds
		var hours = milliseconds / (1000 * 60 * 60);
		var absoluteHours = Math.floor(hours);
		var h = absoluteHours;

		//Get remainder from hours and convert to minutes
		var minutes = (hours - absoluteHours) * 60;
		var absoluteMinutes = Math.floor(minutes);
		var m = absoluteMinutes;

		//Get remainder from minutes and convert to seconds
		var seconds = (minutes - absoluteMinutes) * 60;
		var absoluteSeconds = Math.floor(seconds);
		var s = absoluteSeconds;

		var message = '<span class="Countdown-hours" data-hour-count="' + h + '">';
		message += _Labels.hours(h) + " </span> ";

		message += '<span class="Countdown-minutes" data-minute-count="' + m + '">';
		message += _Labels.minutes(m) + " </span> ";

		message += '<span class="Countdown-seconds" data-second-count="' + s + '">';
		message += _Labels.seconds(s) + " </span> ";

		return message;
	}

	var _Labels = {
		hours: function (value) {
			return (
				value +
				"" +
				(value == 1
					? lang_source.time_labels.hour
					: lang_source.time_labels.hours)
			);
		},
		minutes: function (value) {
			return (
				value +
				"" +
				(value == 1
					? lang_source.time_labels.minute
					: lang_source.time_labels.minutes)
			);
		},
		seconds: function (value) {
			return (
				value +
				"" +
				(value == 1
					? lang_source.time_labels.second
					: lang_source.time_labels.seconds)
			);
		},
	};

	function parseMillisecondsIntoReadableTime(milliseconds) {
		//Get hours from milliseconds
		var hours = milliseconds / (1000 * 60 * 60);
		var absoluteHours = Math.floor(hours);
		var h = absoluteHours;

		//Get remainder from hours and convert to minutes
		var minutes = (hours - absoluteHours) * 60;
		var absoluteMinutes = Math.floor(minutes);
		var m = absoluteMinutes;

		//Get remainder from minutes and convert to seconds
		var seconds = (minutes - absoluteMinutes) * 60;
		var absoluteSeconds = Math.floor(seconds);
		var s = absoluteSeconds;

		var message =
			'<span class="Countdown-item Countdown-hours" data-hour-count="' +
			h +
			'">';
		message += _Labels.hours(h) + " </span> ";

		message +=
			'<span class="Countdown-item Countdown-minutes" data-minute-count="' +
			m +
			'">';
		message += _Labels.minutes(m) + " </span> ";

		message +=
			'<span class="Countdown-item Countdown-seconds" data-second-count="' +
			s +
			'">';
		message += _Labels.seconds(s) + " </span> ";

		return message;
	}

	// IMPORTANT: DO NOT EDIT THIS SECTION MANUALLY.
	// USE shop.metafields.custom.countdown_daily_rules.
	// TODO: Cleanup
	// Default DK rules
	var dailyRules = [
		{
			day: 0,
			label: Labels_day.sunday,
			first_cutoff: {
				hours: 17,
				minutes: 0,
				daysToAdd: 1,
			},
			last_cutoff: {
				hours: 22,
				minutes: 0,
				daysToAdd: 2,
			},
		},
		{
			day: 1,
			label: Labels_day.monday,
			first_cutoff: {
				hours: 16,
				minutes: 30,
				daysToAdd: 1,
			},
			last_cutoff: {
				hours: 22,
				minutes: 0,
				daysToAdd: 2,
			},
		},
		{
			day: 2,
			label: Labels_day.tuesday,
			first_cutoff: {
				hours: 16,
				minutes: 30,
				daysToAdd: 1,
			},
			last_cutoff: {
				hours: 22,
				minutes: 0,
				daysToAdd: 2,
			},
		},
		{
			day: 3,
			label: Labels_day.wednesday,
			first_cutoff: {
				hours: 16,
				minutes: 30,
				daysToAdd: 1,
			},
			last_cutoff: {
				hours: 22,
				minutes: 0,
				daysToAdd: 2,
			},
		},
		{
			day: 4,
			label: Labels_day.thursday,
			first_cutoff: {
				hours: 16,
				minutes: 30,
				daysToAdd: 1,
			},
			last_cutoff: {
				hours: 22,
				minutes: 0,
				daysToAdd: 2,
			},
		},
		{
			day: 5,
			label: Labels_day.friday,
			first_cutoff: {
				hours: 16,
				minutes: 30,
				daysToAdd: 1,
			},
			last_cutoff: {
				hours: 22,
				minutes: 0,
				daysToAdd: 2,
			},
		},
		{
			day: 6,
			label: Labels_day.saturday,
			first_cutoff: {
				hours: 16,
				minutes: 30,
				daysToAdd: 1,
			},
			last_cutoff: {
				hours: 22,
				minutes: 0,
				daysToAdd: 2,
			},
		},
	];

	// READ NOTICE ABOVE
	// Sweden(Sverige)
	if (Shopify && Shopify.shop == "watery-se.myshopify.com") {
		dailyRules = [
			{
				day: 0,
				label: Labels_day.sunday,
				first_cutoff: {
					hours: 17,
					minutes: 0,
					daysToAdd: 3,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 3,
				},
			},
			{
				day: 1,
				label: Labels_day.monday,
				first_cutoff: {
					hours: 17,
					minutes: 0,
					daysToAdd: 2,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 2,
				},
			},
			{
				day: 2,
				label: Labels_day.tuesday,
				first_cutoff: {
					hours: 17,
					minutes: 0,
					daysToAdd: 2,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 2,
				},
			},
			{
				day: 3,
				label: Labels_day.wednesday,
				first_cutoff: {
					hours: 17,
					minutes: 0,
					daysToAdd: 2,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 2,
				},
			},
			{
				day: 4,
				label: Labels_day.thursday,
				first_cutoff: {
					hours: 17,
					minutes: 0,
					daysToAdd: 2,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 4,
				},
			},
			{
				day: 5,
				label: Labels_day.friday,
				first_cutoff: {
					hours: 17,
					minutes: 0,
					daysToAdd: 3,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 3,
				},
			},
			{
				day: 6,
				label: Labels_day.saturday,
				first_cutoff: {
					hours: 17,
					minutes: 0,
					daysToAdd: 3,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 3,
				},
			},
		];
	}

	// READ NOTICE ABOVE
	// Switzerland(Schweiz) rules
	if (Shopify && Shopify.shop == "watery-ch.myshopify.com") {
		dailyRules = [
			{
				day: 0,
				label: Labels_day.sunday,
				first_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 4,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 4,
				},
			},
			{
				day: 1,
				label: Labels_day.monday,
				first_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 4,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 4,
				},
			},
			{
				day: 2,
				label: Labels_day.tuesday,
				first_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 4,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 4,
				},
			},
			{
				day: 3,
				label: Labels_day.wednesday,
				first_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 4,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 4,
				},
			},
			{
				day: 4,
				label: Labels_day.thursday,
				first_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 4,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 6,
				},
			},
			{
				day: 5,
				label: Labels_day.friday,
				first_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 5,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 5,
				},
			},
			{
				day: 6,
				label: Labels_day.saturday,
				first_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 5,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 5,
				},
			},
		];
	}

	// READ NOTICE ABOVE
	// Netherlands(Holland) rules
	if (Shopify && Shopify.shop == "watery-nl.myshopify.com") {
		dailyRules = [
			{
				day: 0,
				label: Labels_day.sunday,
				first_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 3,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 3,
				},
			},
			{
				day: 1,
				label: Labels_day.monday,
				first_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 2,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 2,
				},
			},
			{
				day: 2,
				label: Labels_day.tuesday,
				first_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 2,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 2,
				},
			},
			{
				day: 3,
				label: Labels_day.wednesday,
				first_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 2,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 2,
				},
			},
			{
				day: 4,
				label: Labels_day.thursday,
				first_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 2,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 4,
				},
			},
			{
				day: 5,
				label: Labels_day.friday,
				first_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 3,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 3,
				},
			},
			{
				day: 6,
				label: Labels_day.saturday,
				first_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 3,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 3,
				},
			},
		];
	}

	// READ NOTICE ABOVE
	// Ireland(Irland) rules
	if (Shopify && Shopify.shop == "watery-ie.myshopify.com") {
		dailyRules = [
			{
				day: 0,
				label: Labels_day.sunday,
				first_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 4,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 4,
				},
			},
			{
				day: 1,
				label: Labels_day.monday,
				first_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 3,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 3,
				},
			},
			{
				day: 2,
				label: Labels_day.tuesday,
				first_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 3,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 3,
				},
			},
			{
				day: 3,
				label: Labels_day.wednesday,
				first_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 3,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 3,
				},
			},
			{
				day: 4,
				label: Labels_day.thursday,
				first_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 3,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 5,
				},
			},
			{
				day: 5,
				label: Labels_day.friday,
				first_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 4,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 4,
				},
			},
			{
				day: 6,
				label: Labels_day.saturday,
				first_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 4,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 4,
				},
			},
		];
	}

	// READ NOTICE ABOVE
	// Norway(Norge) rules
	if (Shopify && Shopify.shop == "watery-no.myshopify.com") {
		dailyRules = [
			{
				day: 0,
				label: Labels_day.sunday,
				first_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 3,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 3,
				},
			},
			{
				day: 1,
				label: Labels_day.monday,
				first_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 2,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 2,
				},
			},
			{
				day: 2,
				label: Labels_day.tuesday,
				first_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 2,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 2,
				},
			},
			{
				day: 3,
				label: Labels_day.wednesday,
				first_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 2,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 2,
				},
			},
			{
				day: 4,
				label: Labels_day.thursday,
				first_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 2,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 4,
				},
			},
			{
				day: 5,
				label: Labels_day.friday,
				first_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 3,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 3,
				},
			},
			{
				day: 6,
				label: Labels_day.saturday,
				first_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 3,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 3,
				},
			},
		];
	}

	// READ NOTICE ABOVE
	// Germany(Tyskland) rules
	if (Shopify && Shopify.shop == "watertrendgoods.com.myshopify.com") {
		dailyRules = [
			{
				day: 0,
				label: Labels_day.sunday,
				first_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 3,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 3,
				},
			},
			{
				day: 1,
				label: Labels_day.monday,
				first_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 2,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 2,
				},
			},
			{
				day: 2,
				label: Labels_day.tuesday,
				first_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 2,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 2,
				},
			},
			{
				day: 3,
				label: Labels_day.wednesday,
				first_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 2,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 2,
				},
			},
			{
				day: 4,
				label: Labels_day.thursday,
				first_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 2,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 4,
				},
			},
			{
				day: 5,
				label: Labels_day.friday,
				first_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 3,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 3,
				},
			},
			{
				day: 6,
				label: Labels_day.saturday,
				first_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 3,
				},
				last_cutoff: {
					hours: 19,
					minutes: 0,
					daysToAdd: 3,
				},
			},
		];
	}

	try {
		const dailyRulesJSON = JSON.parse(document.querySelector('#countdown-daily-rules')?.textContent || "null");
		if (dailyRulesJSON) {
			dailyRules = dailyRulesJSON;
			dailyRules.forEach(rule => {
				rule.label = Labels_day[rule.label.toLowerCase()];
			});
		}
	} catch (error) {
		console.error("Error parsing daily rules JSON:", error);
	}

	var buildDateObject = function (obj, day) {
		var startDate = new Date();
		var newDate = new Date(startDate);

		var dayOfWeek = startDate.getDay();
		var targDay = day;

		var addToGetDate = day - dayOfWeek;

		if (dayOfWeek > targDay) {
			addToGetDate += 7;
		}

		// Set up dates
		newDate.setDate(newDate.getDate() + addToGetDate);
		newDate.setHours(obj.hours);
		newDate.setMinutes(obj.minutes);
		newDate.setSeconds(0);

		return newDate;
	};

	var addDayToDate = function (currentDate, incrementBy) {
		var startDate = currentDate;
		var newDate = new Date(startDate);

		newDate.setDate(newDate.getDate() + incrementBy);
		newDate.setHours(startDate.getHours());
		newDate.setMinutes(startDate.getMinutes());
		newDate.setSeconds(startDate.getSeconds());

		return newDate;
	};

	dailyRules.forEach(function (item) {
		item.first_cutoff.date = buildDateObject(item.first_cutoff, item.day);
		item.last_cutoff.date = buildDateObject(item.last_cutoff, item.day);
	});

	var countdownMain = function () {
		var Day = new Date();

		var getDeliveryDateLabel = function (add, translation) {
			var now = Day;
			var obj = addDayToDate(now, add).getDay();

			var tomorrowDay = dailyRules[obj].label;
			var tomorrowLabel = "";

			if (add === 1) {
				tomorrowLabel = Translations.countdown.general.tomorrow;
			}

			translation = translation.replace("[tomorrow]", tomorrowLabel);
			translation = translation.replace("[day]", tomorrowDay);

			return "<strong>" + translation + "</strong>";
		};

		var getTimeUntilNewCutoff = function () {
			var now = Day;
			diff = _Countdown.cutoff.date - now;

			if (diff < 1001) {
				var obj = addDayToDate(now, 1).getDay();
				var targetDate = dailyRules[obj].first_cutoff.date;
				diff = targetDate - now;
			}

			_Countdown.timeUntil = parseMillisecondsIntoReadableTime(diff);
		};

		var DayObj = {
			day: Day.getDay(),
			month: Day.getMonth(),
			dayOfWeeek: Day.getDay(),
			hour: Day.getHours(),
			minute: Day.getMinutes(),
			seconds: Day.getSeconds(),
		};

		var currentDayConfig = dailyRules[DayObj.day];
		currentDayConfig.before = dailyRules[DayObj.day].first_cutoff.date;
		currentDayConfig.after = dailyRules[DayObj.day].last_cutoff.date;

		var _Countdown = {};
		_Countdown.timeUntil = 0;
		_Countdown.cutoff = dailyRules[DayObj.day].first_cutoff;

		if (Day >= currentDayConfig.before) {
			// Check if we are past first cutoff, but between after cutoff
			if (Day < currentDayConfig.after) {
				_Countdown.specialTime = true;
				_Countdown.daysUntilDelivery = _Countdown.cutoff.daysToAdd;
				_Countdown.cutoff = currentDayConfig.last_cutoff;
			} else {
				_Countdown.cutoff = currentDayConfig.last_cutoff;
				_Countdown.daysUntilDelivery = currentDayConfig.last_cutoff.daysToAdd;
			}
		}

		// Are we before first cutoff
		if (Day <= currentDayConfig.before) {
			_Countdown.daysUntilDelivery = _Countdown.cutoff.daysToAdd;
		}

		getTimeUntilNewCutoff();

		countdownOutputs.forEach(function (item) {
			let text = Translations.countdown.text;
			// For header countdown, only visible on desktop
			if (item.hasAttribute("data-header-countdown")) {
				item.innerHTML = `
        <span class='wrapper'>
          <strong>${text.before}</strong>
          <strong>${_Countdown.timeUntil}</strong>
          <span class="subtext">${getDeliveryDateLabel(
					_Countdown.daysUntilDelivery,
					Translations.countdown.header
				)}</span>
        </span>
      `;
				return;
			}

			// For product page
			if (item.hasAttribute("data-sidebar-countdown"))
				item.innerHTML = `
          <span class='wrapper'>
            <strong>${text.before}</strong>
            <strong>${_Countdown.timeUntil}</strong>
            <h5 class='day-label'>${getDeliveryDateLabel(
					_Countdown.daysUntilDelivery,
					Translations.countdown.productpage
				)}</h5>
          </span>
        `;
			// For general, used in cart drawer as of writing this
			else
				item.innerHTML = `
        <span class='wrapper'>
          <strong>${text.before}</strong>
          <strong>${_Countdown.timeUntil}</strong>
          <strong class='day-label'>${getDeliveryDateLabel(
					_Countdown.daysUntilDelivery,
					Translations.countdown.cart
				)}</strong>
        </span>
        `;
		});
	};

	var countdownInstance = false;

	var countdownBegin = function () {
		countdownMain();
		countdownInstance = setInterval(countdownMain, 1000);
	};

	var countdownDestroy = function () {
		clearInterval(countdownInstance);
	};

	var reInit = function () {
		countdownContainers = document.querySelectorAll(
			"[data-shipping-countdown]"
		);
		countdownOutputs = document.querySelectorAll(
			"[data-shipping-countdown-output]"
		);
		countdownBegin();
	};

	return {
		start: countdownBegin,
		stop: countdownDestroy,
		reInit: reInit,
	};
})();

WDN.Countdown.start();

class WDNSearchBlur extends HTMLElement {
	constructor() {
		super();

		this.mount();
	}

	onThisClick() {
		this.findElems();

		document.body.removeAttribute("data-algolia-search-open");

		this.elemsToBlur.forEach(function (element) {
			element.blur();
		});
	}

	findElems() {
		this.elemsToBlur = document.querySelectorAll(".wdn-search .input--search");
	}

	attachListener() {
		this.addEventListener("click", this.onThisClick.bind(this));
	}

	mount() {
		this.attachListener();
	}
}

customElements.define("wdn-search-blurrer", WDNSearchBlur);

(function () {
	var handleSlidesInject;
	var generateTriggers, configureSearchField;
	// Depends on
	var SectionRenderer = WDN.SectionRenderer;
	var Request = WDN.Request;

	// temp
	var headerTemplate = false;

	var SlideTrigger = function (trigger) {
		this.id = trigger.getAttribute("data-slide-trigger");
		this.trigger = trigger;
		this.title = trigger.getAttribute("data-slide-trigger-title");
		this.slide = document.querySelector("[data-slide-name='" + this.id + "']");
		this.headerPlaceholder = document.querySelector(
			"[data-menu-header-placeholder='" + this.id + "']"
		);
		this.injectedHeader = false;
		this.headerTemplate = headerTemplate;
		this.init();
	};

	SlideTrigger.prototype.injectHeader = function () {
		var templateClone = headerTemplate.content.cloneNode(true);
		var title = templateClone.querySelector('[data-menu-header="title"]');
		title.innerHTML = this.title;
		this.headerPlaceholder.appendChild(templateClone);
		this.injectedHeader = true;
	};

	SlideTrigger.prototype.closeActiveSlide = function () {
		var activeSlide = document.querySelector(
			"[data-slide-name][data-slide-open]"
		);
		if (!activeSlide) return;
		activeSlide.removeAttribute("data-slide-open");
	};

	SlideTrigger.prototype.adjustSlides = function () {
		this.closeActiveSlide();
		this.slide.setAttribute("data-slide-open", "");
	};

	SlideTrigger.prototype.bindHeader = function () {
		this.backTriggers = this.slide.querySelectorAll("[data-slide-back]");
		this.backTriggers.forEach((backTrigger) => {
			backTrigger.addEventListener(
				"click",
				this.closeActiveSlide.bind(this)
			);
		});
	};

	SlideTrigger.prototype.handleTriggerClick = function (e) {
		e.preventDefault();
		if (!this.injectedHeader) {
			this.injectHeader();
			this.bindHeader();
		}
		this.adjustSlides();
	};

	SlideTrigger.prototype.init = function () {
		if (!this.slide || !this.headerPlaceholder) return;
		this.trigger.addEventListener("click", this.handleTriggerClick.bind(this));
	};

	generateTriggers = function () {
		document
			.querySelectorAll("[data-slide-trigger]")
			.forEach(function (trigger) {
				new SlideTrigger(trigger);
			});
	};

	configureSearchField = function () {
		var mobileDrawer = document.querySelector(
			'wdn-drawer[data-id="navdrawer"]'
		);
		var pseudoMobileSearchBar = document.querySelector(
			".navdrawer__index-search"
		);

		pseudoMobileSearchBar.addEventListener("click", function () {
			mobileDrawer.close();

			setTimeout(function () { }, 250);
		});
	};

	handleSlidesInject = function () {
		headerTemplate = document.querySelector("[data-menu-header]");
		generateTriggers();
		configureSearchField();
		document.dispatchEvent(
			new CustomEvent("wishlistcount:update", { detail: "" })
		);
	};

	// INIT
	new SectionRenderer({
		selectors: {
			trigger: "wdn-drawer-open[data-id='navdrawer']",
			output: "[data-navdrawer-content]",
		},
		sections: ["async-navdrawer"],
		events: ["click"],
		stripWrapper: true,
		callback: function () {
			// Mobile menu slides generator
			new SectionRenderer({
				selectors: {
					output: "[data-navdrawer-slides]",
				},
				autoInit: true,
				stripWrapper: true,
				sections: ["async-navdrawer-slides"],
				callback: handleSlidesInject,
			});

			var chunkCallback = function () {
				document.dispatchEvent(
					new CustomEvent("mobilemenu:chunk:loaded", { detail: {} })
				);
			};

			// Mobile menu chunk generator
			new SectionRenderer({
				selectors: {
					output: "[data-navdrawer-chunk='placeholder']",
				},
				autoInit: true,
				stripWrapper: true,
				callback: chunkCallback,
				sections: ["async-navdrawer-chunk"],
			});

			// unreliable event as it does not account for the async element of rendering the chunks or slides
			document.dispatchEvent(
				new CustomEvent("mobilemenu:rendered", { detail: {} })
			);
		},
	});
})();

// register mobile load, load async trustpilot element if found
document.addEventListener("mobilemenu:chunk:loaded", () => {
	var elem = document.querySelector(
		".navdrawer__support-group__trustpilot .trustpilot-widget"
	);
	if (elem) {
		Trustpilot.loadFromElement(elem);
	}
});

/* WDN Section renderer element */
(function () {
	var init;

	var elements = document.querySelectorAll("[data-section-renderer]");
	var observer = false;
	var renderedElementsCount = 0;
	var intersectionOptions = {
		rootMargin: "0px 0px 400px 0px", // top left right bottom
	};

	// Intersection observer callback
	var handleIntersection = function (entries) {
		entries.forEach(function (entry) {
			if (entry.isIntersecting) {
				entry.target.render({
					onSuccess: function () {
						// Increment count
						renderedElementsCount++;
						// Check whether all sections are rendered - queryselector because the elements count might've changed
						if (
							renderedElementsCount >=
							document.querySelectorAll("[data-section-renderer]").length
						) {
							stopObserver();
						}
					},
				});
			}
		});
	};

	var stopObserver = function () {
		observer.disconnect();
	};

	var startObserver = function () {
		observer = new IntersectionObserver(
			handleIntersection,
			intersectionOptions
		);
		elements.forEach(function (element) {
			observer.observe(element);
		});
	};

	// Class - make sure it contains [data-section-renderer] attribute (for intersection observer purpose)
	class WDNSectionRenderer extends HTMLElement {
		constructor() {
			super();
			this.replaceContent = this.getAttribute("data-replace-content") === "";
			this.root = this.getAttribute("data-section-root");
			this.sectionNameList = this.getAttribute("data-section-name-list");
			this.useCurrentRoot = this.getAttribute("data-use-current-root") === "";

			this.isRendered = false; // initial state
			this.isFetching = false; // initial state
		}

		output(res) {
			for (var key in res) {
				if (res.hasOwnProperty(key)) {
					var domParser = new DOMParser().parseFromString(
						res[key],
						"text/html"
					);
					var sectionOutput =
						domParser.querySelector(".shopify-section").innerHTML;
					if (this.replaceContent) {
						this.innerHTML = sectionOutput;
						return;
					}
					this.insertAdjacentHTML("beforeend", sectionOutput);
				}
			}
		}

		handleRequestSuccess(res) {
			this.output(res);
			this.isFetching = false;
			this.isRendered = true;
			this.dispatchEvent(new CustomEvent("sections:rendered", { detail: {} }));
			if (typeof this.onSuccess === "function") {
				this.onSuccess();
			}
		}

		handleRequestError() {
			this.isFetching = false;
			this.isRendered = false;
		}

		getRequestURL() {
			var root = Shopify.routes.root;
			// Custom root, eg. if we want to get something in the context of product /products/handle...
			if (this.root && this.root !== "") {
				root = this.root;
			}

			if (this.useCurrentRoot) {
				var UrlParams = new URLSearchParams(window.location.search);
				UrlParams.set("sections", this.sectionNameList);
				return window.location.pathname + "?" + UrlParams.toString();
			}

			return root + "?sections=" + this.sectionNameList;
		}

		sendRequest() {
			if (this.isFetching || this.isRendered) return;

			WDN.Request.Get({
				url: this.getRequestURL(),
				type: "JSON",
				onSuccess: this.handleRequestSuccess.bind(this),
				onError: this.handleRequestError.bind(this),
			});

			this.isFetching = true;
		}

		render(settings) {
			var settings = settings || {};
			if (this.sectionNameList === "") return;
			this.sendRequest();

			// assign callback function to the instance
			if (typeof settings.onSuccess === "function") {
				this.onSuccess = settings.onSuccess;
			}
		}

		connectedCallback() {
			if (this.hasAttribute("allow-reinjects")) {
				this.render();
			}
		}
	}

	/*
		The same as SectionRenderer but it comes with additional settings - limit number of results, ignore specific results
		make sure it contains [data-section-renderer] attribute
		set [data-limit] attribute to limit the number of items
		set [data-ignore-handle] attribute if you want specific handle to be ignored from async items
		asnyc items must contain [data-async-item='handle'] attribute
		if [data-async-item] count is 0, the section will be hidden
  
	*/
	class WDNAdvancedSectionRenderer extends WDNSectionRenderer {
		constructor() {
			super();

			this.replaceContent = this.getAttribute("data-replace-content") === "";
			this.ignoreHandle = this.getAttribute("data-ignore-handle");
			this.limit = parseInt(this.getAttribute("data-limit"));
		}

		output(res) {
			var domParser = new DOMParser();
			for (var key in res) {
				if (res.hasOwnProperty(key)) {
					var parsedSection = domParser.parseFromString(res[key], "text/html");
					var fetchedProducts = Array.from(
						parsedSection.querySelectorAll("[data-async-item]")
					);

					if (this.ignoreHandle !== "") {
						var ignoredItem = parsedSection.querySelector(
							"[data-async-item='" + this.ignoreHandle + "']"
						);

						// If there is ignored item within the results - remove it
						if (ignoredItem) {
							ignoredItem.remove();
						}
					}

					// If more items than the limit - remove extras
					if (fetchedProducts.length > this.limit) {
						fetchedProducts.forEach(function (product, i) {
							if (i < this.limit) return;
							product.remove();
						}, this);
					}

					// handle empty response
					if (
						parsedSection.querySelectorAll("[data-async-item]").length === 0
					) {
						this.closest(".shopify-section").classList.add("hidden");
					}

					// output results
					if (this.replaceContent) {
						this.innerHTML =
							parsedSection.documentElement.querySelector("body").innerHTML;
						return;
					}
					this.insertAdjacentHTML(
						"beforeend",
						parsedSection.documentElement.querySelector("body").innerHTML
					);
				}
			}
		}
	}

	init = function () {
		if (elements.length === 0) return;
		customElements.define("section-renderer", WDNSectionRenderer);
		customElements.define(
			"advanced-section-renderer",
			WDNAdvancedSectionRenderer
		);
		startObserver();
	};

	init();
})();

/* Async video thumbnail + source */
if (typeof WDN.LoadVideoPosters === "undefined") {
	WDN.LoadVideoPosters = function loadVideoPosters(videoEls) {
		var thumbnails = videoEls || document.querySelectorAll("[data-poster]");
		var thumbnailsLoaded = 0;
		var options = {
			rootMargin: "0px 0px 200px 0px",
		};

		var callback = function (entries, observer) {
			entries.forEach(function (entry) {
				if (!entry.isIntersecting) return;
				entry.target.setAttribute(
					"poster",
					entry.target.getAttribute("data-poster")
				);
				thumbnailsLoaded++;
				if (
					thumbnailsLoaded === thumbnails.length
				) {
					intersectionObserver.disconnect();
				}
			});
		};

		var intersectionObserver = new IntersectionObserver(callback, options);

		thumbnails.forEach(function (thumbnail) {
			intersectionObserver.observe(thumbnail);
		});
	}

	WDN.LoadVideoPosters();
}

document.body.addEventListener("overlay:opened", (e) => {
	if (e.detail.id && e.detail.id == "navdrawer") {
		document.body.classList.add("drawer__mobilenav--open");
	}
});

document.body.addEventListener("overlay:closed", (e) => {
	if (e.detail.id && e.detail.id == "navdrawer") {
		document.body.classList.remove("drawer__mobilenav--open");
	}
});

class WDNPreorderPopup extends HTMLElement {
	constructor() {
		super();
		this.relatedModal = this.closest("wdn-modal");
		this.addedFromForm;
	}

	findRelatedModal() {
		if (!this.relatedModal) {
			this.relatedModal = this.closest("wdn-modal");
			if (!this.relatedModal) return false;
		}

		return true;
	}

	openModal() {
		if (!this.findRelatedModal()) return;
		this.relatedModal.open();
	}

	closeModal() {
		if (!this.findRelatedModal()) return;
		this.relatedModal.close();
	}

	onSubmitSuccess() {
		document.body.dispatchEvent(new CustomEvent("cartcount:update"));

		var mobilequickshop = document.querySelector(
			"wdn-modal[data-id='mobile_quickshop']"
		);
		if (mobilequickshop) mobilequickshop.close();

		document.querySelector("wdn-cart").reloadCart();
		this.closeModal();
	}

	addPreorderToCart(itemsToAdd) {
		fetch(window.Shopify.routes.root + "cart/add.js", {
			method: "POST",
			body: JSON.stringify(itemsToAdd),
			headers: {
				"Content-Type": "application/json",
			},
		})
			.then((response) => {
				this.onSubmitSuccess.call(this);
			})
			.catch((error) => {
				console.error("Error:", error);
			});
	}

	onFormSubmit(e) {
		this.formData = new FormData(this.form);
		this.oldFormData = new FormData(this.addedFromForm);

		var itemQty =
			this.oldFormData.get("quantity") ||
			this.oldFormData.get("items[0]quantity") ||
			1;
		var termsCheck = this.form.querySelector("wdn-checkbox");

		if (!termsCheck.isChecked) {
			termsCheck.setAttribute("data-error", "");
			return;
		}

		var itemsToAdd = {};
		itemsToAdd.items = [];
		var preorderItemProps = {};

		for (var formDataProperty of this.formData.entries()) {
			if (formDataProperty[0].indexOf("properties") > -1) {
				preorderItemProps[
					formDataProperty[0].replaceAll("properties[", "").replaceAll("]", "")
				] = formDataProperty[1];
			}
		}

		itemsToAdd.items.push({
			id: this.formData.get("id"),
			quantity: itemQty,
			properties: preorderItemProps,
		});

		var isAddedFromProductpageMainForm =
			!!this.addedFromForm.closest(".Productpage");

		/* found on pdp, check if any of these are checked */
		var bundlesContainer = document.querySelector("wdn-bundle-form");

		if (isAddedFromProductpageMainForm && bundlesContainer) {
			var bundleCheckboxList =
				bundlesContainer.querySelectorAll("wdn-checkbox");
			var bundleCheckedCheckboxes = Array.from(bundleCheckboxList).filter(
				(elem) => {
					if (elem.isChecked) {
						return true;
					}
				}
			);

			if (bundleCheckedCheckboxes.length > 0) {
				bundleCheckedCheckboxes.forEach((elem) => {
					itemsToAdd.items.push({
						id: elem.getAttribute("data-value"),
						quantity: 1,
					});
				});
			}
		}

		var addonContainer = document.querySelector(
			".Productpage [data-product-addons-content]"
		);
		if (isAddedFromProductpageMainForm && addonContainer) {
			var addonCheckboxList =
				addonContainer.querySelectorAll("wdn-addon-checkbox");
			var addonCheckedCheckboxes = Array.from(addonCheckboxList).filter(
				(elem) => {
					if (elem.isChecked) {
						return true;
					}
				}
			);

			if (addonCheckedCheckboxes.length > 0) {
				addonCheckedCheckboxes.forEach((elem) => {
					itemsToAdd.items.push({
						id: elem.getAttribute("data-value"),
						quantity: 1,
					});
				});
			}
		}

		termsCheck.removeAttribute("data-error");
		this.addPreorderToCart(itemsToAdd);
	}

	listenForFormSubmit() {
		this.form = this.querySelector("form");

		this.form.addEventListener("submit", (event) => {
			event.preventDefault();
			this.onFormSubmit();
		});
	}

	loadProductContent(productHandle, variantID) {
		let requestRoute =
			window.Shopify.routes.root +
			"products/" +
			productHandle +
			"?section_id=async-preorder-popup";

		if (variantID) {
			requestRoute += "&variant=" + variantID;
		}

		fetch(requestRoute)
			.then((res) => res.text())
			.then((text) => {
				const parsedDOM = new DOMParser().parseFromString(text, "text/html");
				const sectionDOM = parsedDOM.querySelector(".shopify-section");

				this.innerHTML = sectionDOM.innerHTML;
				this.listenForFormSubmit();
			});
	}

	openModalAndLoad(productHandle, variantID) {
		this.openModal();
		this.loadProductContent(productHandle, variantID);
	}
}
customElements.define("wdn-preorder-popup", WDNPreorderPopup);

class WDNDisclosure extends HTMLElement {
	constructor() {
		super();
		this.trigger = this.querySelector("[data-disclosure-label]");
		this.content = this.querySelector("[data-disclosure-content]");

		this.trigger.addEventListener("click", () => {
			this.focus();
		});
	}
}

customElements.define("wdn-disclosure", WDNDisclosure);

document.body.addEventListener("overlay:closed", function (r) {
	if (
		r.detail &&
		r.detail.getAttribute("data-id") &&
		r.detail.getAttribute("data-id") === "cart_bfcm_upsell"
	) {
		var cartDrawer = document.querySelector('wdn-drawer[data-id="cart"]');
		document.body.classList.remove('cart-bfcm-upsell--open');
		if (cartDrawer) {
			cartDrawer.classList.add('modal-zindex');
		}
	}
});
